package com.example.mystybag.common.resources

import dev.icerock.moko.graphics.Color
import dev.icerock.moko.resources.ColorResource
import dev.icerock.moko.resources.ImageResource
import dev.icerock.moko.resources.ResourceContainer
import dev.icerock.moko.resources.ResourcePlatformDetails
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.RemoteJsStringLoaderHolder
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

public actual object SR {
  private val contentHash: String = "8fa61a5bd9a2e6f0e35b82a7dddcf3b7"

  public actual object strings : ResourceContainer<StringResource>, RemoteJsStringLoaderHolder {
    actual override val __platformDetails: ResourcePlatformDetails = ResourcePlatformDetails()

    private val fallbackFileUrl: String =
        js("require(\"./localization/comexamplemystybagcommonresources_stringsJson.json\")") as
        String

    private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
        SupportedLocale("el",
            js("require(\"./localization/comexamplemystybagcommonresources_stringsJson_el.json\")")
            as String),
        SupportedLocale("it",
            js("require(\"./localization/comexamplemystybagcommonresources_stringsJson_it.json\")")
            as String),
        SupportedLocale("ro",
            js("require(\"./localization/comexamplemystybagcommonresources_stringsJson_ro.json\")")
            as String),
        SupportedLocale("nl",
            js("require(\"./localization/comexamplemystybagcommonresources_stringsJson_nl.json\")")
            as String),
        SupportedLocale("bg",
            js("require(\"./localization/comexamplemystybagcommonresources_stringsJson_bg.json\")")
            as String),
        SupportedLocale("de",
            js("require(\"./localization/comexamplemystybagcommonresources_stringsJson_de.json\")")
            as String),
        SupportedLocale("fr",
            js("require(\"./localization/comexamplemystybagcommonresources_stringsJson_fr.json\")")
            as String),
        SupportedLocale("es",
            js("require(\"./localization/comexamplemystybagcommonresources_stringsJson_es.json\")")
            as String),
        ))

    override val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
        supportedLocales, fallbackFileUri = fallbackFileUrl)

    public actual val support_email: StringResource = StringResource(key = "support_email", loader =
        stringsLoader)

    public actual val share_to: StringResource = StringResource(key = "share_to", loader =
        stringsLoader)

    public actual val text_copy: StringResource = StringResource(key = "text_copy", loader =
        stringsLoader)

    public actual val menu: StringResource = StringResource(key = "menu", loader = stringsLoader)

    public actual val update_message: StringResource = StringResource(key = "update_message", loader
        = stringsLoader)

    public actual val oops_something_went_wrong: StringResource = StringResource(key =
        "oops_something_went_wrong", loader = stringsLoader)

    public actual val document_rejected: StringResource = StringResource(key = "document_rejected",
        loader = stringsLoader)

    public actual val weekday_saturday: StringResource = StringResource(key = "weekday_saturday",
        loader = stringsLoader)

    public actual val weekday_friday: StringResource = StringResource(key = "weekday_friday", loader
        = stringsLoader)

    public actual val weekday_thursday: StringResource = StringResource(key = "weekday_thursday",
        loader = stringsLoader)

    public actual val weekday_wednesday: StringResource = StringResource(key = "weekday_wednesday",
        loader = stringsLoader)

    public actual val weekday_tuesday: StringResource = StringResource(key = "weekday_tuesday",
        loader = stringsLoader)

    public actual val weekday_monday: StringResource = StringResource(key = "weekday_monday", loader
        = stringsLoader)

    public actual val weekday_sunday: StringResource = StringResource(key = "weekday_sunday", loader
        = stringsLoader)

    public actual val an_error_occurred_please_try_again_later: StringResource = StringResource(key
        = "an_error_occurred_please_try_again_later", loader = stringsLoader)

    public actual val no_internet_connection: StringResource = StringResource(key =
        "no_internet_connection", loader = stringsLoader)

    public actual val please_log_in_again: StringResource = StringResource(key =
        "please_log_in_again", loader = stringsLoader)

    public actual val delivery: StringResource = StringResource(key = "delivery", loader =
        stringsLoader)

    public actual val favorites: StringResource = StringResource(key = "favorites", loader =
        stringsLoader)

    public actual val profile: StringResource = StringResource(key = "profile", loader =
        stringsLoader)

    public actual val list: StringResource = StringResource(key = "list", loader = stringsLoader)

    public actual val map: StringResource = StringResource(key = "map", loader = stringsLoader)

    public actual val skip: StringResource = StringResource(key = "skip", loader = stringsLoader)

    public actual val total_reservations: StringResource = StringResource(key =
        "total_reservations", loader = stringsLoader)

    public actual val not_picked_reservations: StringResource = StringResource(key =
        "not_picked_reservations", loader = stringsLoader)

    public actual val collect_for_lunch: StringResource = StringResource(key = "collect_for_lunch",
        loader = stringsLoader)

    public actual val collect_for_dinner: StringResource = StringResource(key =
        "collect_for_dinner", loader = stringsLoader)

    public actual val new_surprise_bags: StringResource = StringResource(key = "new_surprise_bags",
        loader = stringsLoader)

    public actual val meals: StringResource = StringResource(key = "meals", loader = stringsLoader)

    public actual val selling_fast: StringResource = StringResource(key = "selling_fast", loader =
        stringsLoader)

    public actual val left: StringResource = StringResource(key = "left", loader = stringsLoader)

    public actual val surprise_bag: StringResource = StringResource(key = "surprise_bag", loader =
        stringsLoader)

    public actual val collect: StringResource = StringResource(key = "collect", loader =
        stringsLoader)

    public actual val what_you_could_get: StringResource = StringResource(key =
        "what_you_could_get", loader = stringsLoader)

    public actual val overall_experience: StringResource = StringResource(key =
        "overall_experience", loader = stringsLoader)

    public actual val based_on_reviews: StringResource = StringResource(key = "based_on_reviews",
        loader = stringsLoader)

    public actual val reserve: StringResource = StringResource(key = "reserve", loader =
        stringsLoader)

    public actual val item_selling_fast: StringResource = StringResource(key = "item_selling_fast",
        loader = stringsLoader)

    public actual val surprise_bag_high_demand: StringResource = StringResource(key =
        "surprise_bag_high_demand", loader = stringsLoader)

    public actual val confirm: StringResource = StringResource(key = "confirm", loader =
        stringsLoader)

    public actual val location: StringResource = StringResource(key = "location", loader =
        stringsLoader)

    public actual val reservation_success: StringResource = StringResource(key =
        "reservation_success", loader = stringsLoader)

    public actual val reservation_success_message: StringResource = StringResource(key =
        "reservation_success_message", loader = stringsLoader)

    public actual val reservation_error: StringResource = StringResource(key = "reservation_error",
        loader = stringsLoader)

    public actual val reservation_error_message: StringResource = StringResource(key =
        "reservation_error_message", loader = stringsLoader)

    public actual val reservation_id: StringResource = StringResource(key = "reservation_id", loader
        = stringsLoader)

    public actual val reservation_number: StringResource = StringResource(key =
        "reservation_number", loader = stringsLoader)

    public actual val bag_id: StringResource = StringResource(key = "bag_id", loader =
        stringsLoader)

    public actual val view_bag: StringResource = StringResource(key = "view_bag", loader =
        stringsLoader)

    public actual val reserved_on: StringResource = StringResource(key = "reserved_on", loader =
        stringsLoader)

    public actual val received_on: StringResource = StringResource(key = "received_on", loader =
        stringsLoader)

    public actual val status: StringResource = StringResource(key = "status", loader =
        stringsLoader)

    public actual val no_reservations: StringResource = StringResource(key = "no_reservations",
        loader = stringsLoader)

    public actual val unlock_for_delivery: StringResource = StringResource(key =
        "unlock_for_delivery", loader = stringsLoader)

    public actual val updating_reservation: StringResource = StringResource(key =
        "updating_reservation", loader = stringsLoader)

    public actual val reservation_details: StringResource = StringResource(key =
        "reservation_details", loader = stringsLoader)

    public actual val released_by_client: StringResource = StringResource(key =
        "released_by_client", loader = stringsLoader)

    public actual val reserved: StringResource = StringResource(key = "reserved", loader =
        stringsLoader)

    public actual val received: StringResource = StringResource(key = "received", loader =
        stringsLoader)

    public actual val error: StringResource = StringResource(key = "error", loader = stringsLoader)

    public actual val collection_experience: StringResource = StringResource(key =
        "collection_experience", loader = stringsLoader)

    public actual val food_quality: StringResource = StringResource(key = "food_quality", loader =
        stringsLoader)

    public actual val variety_of_contents: StringResource = StringResource(key =
        "variety_of_contents", loader = stringsLoader)

    public actual val food_quantity: StringResource = StringResource(key = "food_quantity", loader =
        stringsLoader)

    public actual val allergens: StringResource = StringResource(key = "allergens", loader =
        stringsLoader)

    public actual val product_contains_no_allergens: StringResource = StringResource(key =
        "product_contains_no_allergens", loader = stringsLoader)

    public actual val allergen_gluten: StringResource = StringResource(key = "allergen_gluten",
        loader = stringsLoader)

    public actual val allergen_crustaceans: StringResource = StringResource(key =
        "allergen_crustaceans", loader = stringsLoader)

    public actual val allergen_eggs: StringResource = StringResource(key = "allergen_eggs", loader =
        stringsLoader)

    public actual val allergen_fish: StringResource = StringResource(key = "allergen_fish", loader =
        stringsLoader)

    public actual val allergen_peanuts: StringResource = StringResource(key = "allergen_peanuts",
        loader = stringsLoader)

    public actual val allergen_soybeans: StringResource = StringResource(key = "allergen_soybeans",
        loader = stringsLoader)

    public actual val allergen_milk: StringResource = StringResource(key = "allergen_milk", loader =
        stringsLoader)

    public actual val allergen_nuts: StringResource = StringResource(key = "allergen_nuts", loader =
        stringsLoader)

    public actual val allergen_celery: StringResource = StringResource(key = "allergen_celery",
        loader = stringsLoader)

    public actual val allergen_mustard: StringResource = StringResource(key = "allergen_mustard",
        loader = stringsLoader)

    public actual val allergen_sesame: StringResource = StringResource(key = "allergen_sesame",
        loader = stringsLoader)

    public actual val allergen_sulphur_dioxide: StringResource = StringResource(key =
        "allergen_sulphur_dioxide", loader = stringsLoader)

    public actual val allergen_lupin: StringResource = StringResource(key = "allergen_lupin", loader
        = stringsLoader)

    public actual val allergen_molluscs: StringResource = StringResource(key = "allergen_molluscs",
        loader = stringsLoader)

    public actual val rate_your_experience: StringResource = StringResource(key =
        "rate_your_experience", loader = stringsLoader)

    public actual val rate_your_experience_description: StringResource = StringResource(key =
        "rate_your_experience_description", loader = stringsLoader)

    public actual val submit_review: StringResource = StringResource(key = "submit_review", loader =
        stringsLoader)

    public actual val review_submitted_successfully: StringResource = StringResource(key =
        "review_submitted_successfully", loader = stringsLoader)

    public actual val bags_count: StringResource = StringResource(key = "bags_count", loader =
        stringsLoader)

    public actual val available_bags: StringResource = StringResource(key = "available_bags", loader
        = stringsLoader)

    public actual val select_time: StringResource = StringResource(key = "select_time", loader =
        stringsLoader)

    public actual val checkout_temporary_problem: StringResource = StringResource(key =
        "checkout_temporary_problem", loader = stringsLoader)

    public actual val try_again: StringResource = StringResource(key = "try_again", loader =
        stringsLoader)

    public actual val back: StringResource = StringResource(key = "back", loader = stringsLoader)

    public actual val checkout_connecting_secure_payment: StringResource = StringResource(key =
        "checkout_connecting_secure_payment", loader = stringsLoader)

    public actual val operation_not_supported_by_device: StringResource = StringResource(key =
        "operation_not_supported_by_device", loader = stringsLoader)

    public actual val log_out: StringResource = StringResource(key = "log_out", loader =
        stringsLoader)

    public actual val are_you_sure_you_want_to_proceed: StringResource = StringResource(key =
        "are_you_sure_you_want_to_proceed", loader = stringsLoader)

    public actual val continue_camel_case: StringResource = StringResource(key =
        "continue_camel_case", loader = stringsLoader)

    public actual val log_out_yes: StringResource = StringResource(key = "log_out_yes", loader =
        stringsLoader)

    public actual val cancel: StringResource = StringResource(key = "cancel", loader =
        stringsLoader)

    public actual val section_account: StringResource = StringResource(key = "section_account",
        loader = stringsLoader)

    public actual val section_mystybag: StringResource = StringResource(key = "section_mystybag",
        loader = stringsLoader)

    public actual val section_personal_info: StringResource = StringResource(key =
        "section_personal_info", loader = stringsLoader)

    public actual val section_other: StringResource = StringResource(key = "section_other", loader =
        stringsLoader)

    public actual val delete_account: StringResource = StringResource(key = "delete_account", loader
        = stringsLoader)

    public actual val submit_request: StringResource = StringResource(key = "submit_request", loader
        = stringsLoader)

    public actual val delete_account_request_description: StringResource = StringResource(key =
        "delete_account_request_description", loader = stringsLoader)

    public actual val delete_account_request_tap_to_send: StringResource = StringResource(key =
        "delete_account_request_tap_to_send", loader = stringsLoader)

    public actual val your_enquiry: StringResource = StringResource(key = "your_enquiry", loader =
        stringsLoader)

    public actual val contact_support: StringResource = StringResource(key = "contact_support",
        loader = stringsLoader)

    public actual val delete_account_request_sent: StringResource = StringResource(key =
        "delete_account_request_sent", loader = stringsLoader)

    public actual val delete_account_request_pending_message: StringResource = StringResource(key =
        "delete_account_request_pending_message", loader = stringsLoader)

    public actual val name: StringResource = StringResource(key = "name", loader = stringsLoader)

    public actual val your_name: StringResource = StringResource(key = "your_name", loader =
        stringsLoader)

    public actual val name_required: StringResource = StringResource(key = "name_required", loader =
        stringsLoader)

    public actual val mobile_number: StringResource = StringResource(key = "mobile_number", loader =
        stringsLoader)

    public actual val change_mobile_number_verification_info: StringResource = StringResource(key =
        "change_mobile_number_verification_info", loader = stringsLoader)

    public actual val notifications: StringResource = StringResource(key = "notifications", loader =
        stringsLoader)

    public actual val notifications_on_discounts_and_other_news: StringResource = StringResource(key
        = "notifications_on_discounts_and_other_news", loader = stringsLoader)

    public actual val reservation_completed: StringResource = StringResource(key =
        "reservation_completed", loader = stringsLoader)

    public actual val push: StringResource = StringResource(key = "push", loader = stringsLoader)

    public actual val payment_methods: StringResource = StringResource(key = "payment_methods",
        loader = stringsLoader)

    public actual val stored_cards_title: StringResource = StringResource(key =
        "stored_cards_title", loader = stringsLoader)

    public actual val cards_section_title: StringResource = StringResource(key =
        "cards_section_title", loader = stringsLoader)

    public actual val no_stored_cards: StringResource = StringResource(key = "no_stored_cards",
        loader = stringsLoader)

    public actual val help_center: StringResource = StringResource(key = "help_center", loader =
        stringsLoader)

    public actual val about_mystybag: StringResource = StringResource(key = "about_mystybag", loader
        = stringsLoader)

    public actual val terms_of_use: StringResource = StringResource(key = "terms_of_use", loader =
        stringsLoader)

    public actual val app_version: StringResource = StringResource(key = "app_version", loader =
        stringsLoader)

    public actual val unlock_with_fingerprint: StringResource = StringResource(key =
        "unlock_with_fingerprint", loader = stringsLoader)

    public actual val touch_the_fingerprint_sensor: StringResource = StringResource(key =
        "touch_the_fingerprint_sensor", loader = stringsLoader)

    public actual val face_id: StringResource = StringResource(key = "face_id", loader =
        stringsLoader)

    public actual val use_your_fingerprint: StringResource = StringResource(key =
        "use_your_fingerprint", loader = stringsLoader)

    public actual val choose_country_region: StringResource = StringResource(key =
        "choose_country_region", loader = stringsLoader)

    public actual val still_having_issue_contact_us: StringResource = StringResource(key =
        "still_having_issue_contact_us", loader = stringsLoader)

    public actual val new_update_is_available: StringResource = StringResource(key =
        "new_update_is_available", loader = stringsLoader)

    public actual val it_looks_like_you_have_an_older_version: StringResource = StringResource(key =
        "it_looks_like_you_have_an_older_version", loader = stringsLoader)

    public actual val no_results_found: StringResource = StringResource(key = "no_results_found",
        loader = stringsLoader)

    public actual val service_temporarily_unavailable: StringResource = StringResource(key =
        "service_temporarily_unavailable", loader = stringsLoader)

    public actual val not_allowed_symbol: StringResource = StringResource(key =
        "not_allowed_symbol", loader = stringsLoader)

    public actual
        val go_to_your_phone_settings_allow_access_to_your_contacts_and_send_money_to_your_friends_easily:
        StringResource = StringResource(key =
        "go_to_your_phone_settings_allow_access_to_your_contacts_and_send_money_to_your_friends_easily",
        loader = stringsLoader)

    public actual val search_by_name_or_mobile_number: StringResource = StringResource(key =
        "search_by_name_or_mobile_number", loader = stringsLoader)

    public actual val you_have_reached_the_maximum_number_of_characters: StringResource =
        StringResource(key = "you_have_reached_the_maximum_number_of_characters", loader =
        stringsLoader)

    public actual val not_allowed_symbol_please_use_only_numbers: StringResource =
        StringResource(key = "not_allowed_symbol_please_use_only_numbers", loader = stringsLoader)

    public actual val contact_us: StringResource = StringResource(key = "contact_us", loader =
        stringsLoader)

    public actual val update: StringResource = StringResource(key = "update", loader =
        stringsLoader)

    public actual val mystybag_new_version: StringResource = StringResource(key =
        "mystybag_new_version", loader = stringsLoader)

    public actual val close: StringResource = StringResource(key = "close", loader = stringsLoader)

    public actual val type_to_search: StringResource = StringResource(key = "type_to_search", loader
        = stringsLoader)

    public actual val search_products_and_places: StringResource = StringResource(key =
        "search_products_and_places", loader = stringsLoader)

    public actual val ok: StringResource = StringResource(key = "ok", loader = stringsLoader)

    public actual val filter: StringResource = StringResource(key = "filter", loader =
        stringsLoader)

    public actual val what_can_i_do_title: StringResource = StringResource(key =
        "what_can_i_do_title", loader = stringsLoader)

    public actual val possible_reasons: StringResource = StringResource(key = "possible_reasons",
        loader = stringsLoader)

    public actual val your_internet_connection_is_not_strong_enough: StringResource =
        StringResource(key = "your_internet_connection_is_not_strong_enough", loader =
        stringsLoader)

    public actual val you_have_turned_off_your_wifi_or_mobile_data: StringResource =
        StringResource(key = "you_have_turned_off_your_wifi_or_mobile_data", loader = stringsLoader)

    public actual val your_phone_is_in_plane_mode: StringResource = StringResource(key =
        "your_phone_is_in_plane_mode", loader = stringsLoader)

    public actual val the_app_cannot_establish_a_secure_connection_with_our_servers: StringResource
        = StringResource(key = "the_app_cannot_establish_a_secure_connection_with_our_servers",
        loader = stringsLoader)

    public actual val what_can_i_do: StringResource = StringResource(key = "what_can_i_do", loader =
        stringsLoader)

    public actual val check_for_app_updates: StringResource = StringResource(key =
        "check_for_app_updates", loader = stringsLoader)

    public actual val make_sure_you_re_using_the_latest_version_of_the_app: StringResource =
        StringResource(key = "make_sure_you_re_using_the_latest_version_of_the_app", loader =
        stringsLoader)

    public actual val check_your_internet_connection: StringResource = StringResource(key =
        "check_your_internet_connection", loader = stringsLoader)

    public actual val try_using_mystybag_both_on_wifi_and_on_your_mobile_data_connection:
        StringResource = StringResource(key =
        "try_using_mystybag_both_on_wifi_and_on_your_mobile_data_connection", loader =
        stringsLoader)

    public actual val restart_your_phone: StringResource = StringResource(key =
        "restart_your_phone", loader = stringsLoader)

    public actual val try_restarting_your_phone_it_may_help_to_clear_your_cash_and_data_leaks:
        StringResource = StringResource(key =
        "try_restarting_your_phone_it_may_help_to_clear_your_cash_and_data_leaks", loader =
        stringsLoader)

    public actual val reinstall_the_app: StringResource = StringResource(key = "reinstall_the_app",
        loader = stringsLoader)

    public actual val if_restarting_your_device_and_checking_your_connection_do_not_help:
        StringResource = StringResource(key =
        "if_restarting_your_device_and_checking_your_connection_do_not_help", loader =
        stringsLoader)

    public actual val enjoying_mystybag: StringResource = StringResource(key = "enjoying_mystybag",
        loader = stringsLoader)

    public actual val enjoying_mystybag_mind_giving_us_a_5_star_rating_on_play_store: StringResource
        = StringResource(key = "enjoying_mystybag_mind_giving_us_a_5_star_rating_on_play_store",
        loader = stringsLoader)

    public actual val later: StringResource = StringResource(key = "later", loader = stringsLoader)

    public actual val rate_us_5_star: StringResource = StringResource(key = "rate_us_5_star", loader
        = stringsLoader)

    public actual val got_it: StringResource = StringResource(key = "got_it", loader =
        stringsLoader)

    public actual val please_use_only_latin_letters: StringResource = StringResource(key =
        "please_use_only_latin_letters", loader = stringsLoader)

    public actual val permission_not_allowed: StringResource = StringResource(key =
        "permission_not_allowed", loader = stringsLoader)

    public actual val crop: StringResource = StringResource(key = "crop", loader = stringsLoader)

    public actual val black_text: StringResource = StringResource(key = "black_text", loader =
        stringsLoader)

    public actual val white_text: StringResource = StringResource(key = "white_text", loader =
        stringsLoader)

    public actual val printing_is_unavailable: StringResource = StringResource(key =
        "printing_is_unavailable", loader = stringsLoader)

    public actual val successfully_saved_to_device: StringResource = StringResource(key =
        "successfully_saved_to_device", loader = stringsLoader)

    public actual val download_failed: StringResource = StringResource(key = "download_failed",
        loader = stringsLoader)

    public actual val storage_permission: StringResource = StringResource(key =
        "storage_permission", loader = stringsLoader)

    public actual val save_to_my_device: StringResource = StringResource(key = "save_to_my_device",
        loader = stringsLoader)

    public actual val invalid_phone_number: StringResource = StringResource(key =
        "invalid_phone_number", loader = stringsLoader)

    public actual val next: StringResource = StringResource(key = "next", loader = stringsLoader)

    public actual val personal_details: StringResource = StringResource(key = "personal_details",
        loader = stringsLoader)

    public actual val profile_photo: StringResource = StringResource(key = "profile_photo", loader =
        stringsLoader)

    public actual val take_photo: StringResource = StringResource(key = "take_photo", loader =
        stringsLoader)

    public actual val open_gallery: StringResource = StringResource(key = "open_gallery", loader =
        stringsLoader)

    public actual val remove_photo: StringResource = StringResource(key = "remove_photo", loader =
        stringsLoader)

    public actual val please_enter_valid_email_address: StringResource = StringResource(key =
        "please_enter_valid_email_address", loader = stringsLoader)

    public actual val camera_permission: StringResource = StringResource(key = "camera_permission",
        loader = stringsLoader)

    public actual val gallery_permission: StringResource = StringResource(key =
        "gallery_permission", loader = stringsLoader)

    public actual val login: StringResource = StringResource(key = "login", loader = stringsLoader)

    public actual val not_now: StringResource = StringResource(key = "not_now", loader =
        stringsLoader)

    public actual val enable: StringResource = StringResource(key = "enable", loader =
        stringsLoader)

    public actual val phone_number: StringResource = StringResource(key = "phone_number", loader =
        stringsLoader)

    public actual val do_you_wish_to_turn_on_face_id_access: StringResource = StringResource(key =
        "do_you_wish_to_turn_on_face_id_access", loader = stringsLoader)

    public actual val do_you_wish_to_turn_on_fingerprint_access: StringResource = StringResource(key
        = "do_you_wish_to_turn_on_fingerprint_access", loader = stringsLoader)

    public actual val email: StringResource = StringResource(key = "email", loader = stringsLoader)

    public actual val login_with_fingerprint: StringResource = StringResource(key =
        "login_with_fingerprint", loader = stringsLoader)

    public actual val login_with_faceID: StringResource = StringResource(key = "login_with_faceID",
        loader = stringsLoader)

    public actual val yesterday: StringResource = StringResource(key = "yesterday", loader =
        stringsLoader)

    public actual val no_notifications_found: StringResource = StringResource(key =
        "no_notifications_found", loader = stringsLoader)

    public actual val add_company_contact: StringResource = StringResource(key =
        "add_company_contact", loader = stringsLoader)

    public actual val company_not_found: StringResource = StringResource(key = "company_not_found",
        loader = stringsLoader)

    public actual val section_details: StringResource = StringResource(key = "section_details",
        loader = stringsLoader)

    public actual val section_price: StringResource = StringResource(key = "section_price", loader =
        stringsLoader)

    public actual val forgot_password: StringResource = StringResource(key = "forgot_password",
        loader = stringsLoader)

    public actual val change_password: StringResource = StringResource(key = "change_password",
        loader = stringsLoader)

    public actual val reset_password: StringResource = StringResource(key = "reset_password", loader
        = stringsLoader)

    public actual val temporary_password: StringResource = StringResource(key =
        "temporary_password", loader = stringsLoader)

    public actual val new_password: StringResource = StringResource(key = "new_password", loader =
        stringsLoader)

    public actual val forgot_password_email_sent: StringResource = StringResource(key =
        "forgot_password_email_sent", loader = stringsLoader)

    public actual val password_reset_success: StringResource = StringResource(key =
        "password_reset_success", loader = stringsLoader)

    public actual val password_requirements_not_met: StringResource = StringResource(key =
        "password_requirements_not_met", loader = stringsLoader)

    public actual val please_enter_temporary_password: StringResource = StringResource(key =
        "please_enter_temporary_password", loader = stringsLoader)

    public actual val collect_today: StringResource = StringResource(key = "collect_today", loader =
        stringsLoader)

    public actual val collect_tomorrow: StringResource = StringResource(key = "collect_tomorrow",
        loader = stringsLoader)

    public actual val vegetarian: StringResource = StringResource(key = "vegetarian", loader =
        stringsLoader)

    public actual val vegan: StringResource = StringResource(key = "vegan", loader = stringsLoader)

    public actual val see_all: StringResource = StringResource(key = "see_all", loader =
        stringsLoader)

    public actual val dashboard: StringResource = StringResource(key = "dashboard", loader =
        stringsLoader)

    public actual val performance: StringResource = StringResource(key = "performance", loader =
        stringsLoader)

    public actual val financials: StringResource = StringResource(key = "financials", loader =
        stringsLoader)

    public actual val settings: StringResource = StringResource(key = "settings", loader =
        stringsLoader)

    public actual val home: StringResource = StringResource(key = "home", loader = stringsLoader)

    public actual val section_application_settings: StringResource = StringResource(key =
        "section_application_settings", loader = stringsLoader)

    public actual val section_appearance: StringResource = StringResource(key =
        "section_appearance", loader = stringsLoader)

    public actual val theme_light: StringResource = StringResource(key = "theme_light", loader =
        stringsLoader)

    public actual val theme_dark: StringResource = StringResource(key = "theme_dark", loader =
        stringsLoader)

    public actual val theme_system: StringResource = StringResource(key = "theme_system", loader =
        stringsLoader)

    public actual val `value`: StringResource = StringResource(key = "value", loader =
        stringsLoader)

    public actual val language: StringResource = StringResource(key = "language", loader =
        stringsLoader)

    public actual val email_address: StringResource = StringResource(key = "email_address", loader =
        stringsLoader)

    public actual val change_email_verification_info: StringResource = StringResource(key =
        "change_email_verification_info", loader = stringsLoader)

    public actual val bulgarian: StringResource = StringResource(key = "bulgarian", loader =
        stringsLoader)

    public actual val english: StringResource = StringResource(key = "english", loader =
        stringsLoader)

    public actual val map_web_placeholder: StringResource = StringResource(key =
        "map_web_placeholder", loader = stringsLoader)

    public actual val please_select_location_on_map: StringResource = StringResource(key =
        "please_select_location_on_map", loader = stringsLoader)

    public actual val merchant_location_map_search_hint: StringResource = StringResource(key =
        "merchant_location_map_search_hint", loader = stringsLoader)

    public actual val view_possible_products: StringResource = StringResource(key =
        "view_possible_products", loader = stringsLoader)

    public actual val reviews_count: StringResource = StringResource(key = "reviews_count", loader =
        stringsLoader)

    public actual val no_reviews: StringResource = StringResource(key = "no_reviews", loader =
        stringsLoader)

    public actual val open_until: StringResource = StringResource(key = "open_until", loader =
        stringsLoader)

    public actual val description: StringResource = StringResource(key = "description", loader =
        stringsLoader)

    public actual val available_count: StringResource = StringResource(key = "available_count",
        loader = stringsLoader)

    public actual val reserve_a_bag: StringResource = StringResource(key = "reserve_a_bag", loader =
        stringsLoader)

    public actual val how_many_bags_would_you_like_to_reserve: StringResource = StringResource(key =
        "how_many_bags_would_you_like_to_reserve", loader = stringsLoader)

    public actual val more_available: StringResource = StringResource(key = "more_available", loader
        = stringsLoader)

    public actual val last_bag: StringResource = StringResource(key = "last_bag", loader =
        stringsLoader)

    public actual val pickup_window_open_title: StringResource = StringResource(key =
        "pickup_window_open_title", loader = stringsLoader)

    public actual val pickup_window_open_message: StringResource = StringResource(key =
        "pickup_window_open_message", loader = stringsLoader)

    public actual val pickup_walk_time: StringResource = StringResource(key = "pickup_walk_time",
        loader = stringsLoader)

    public actual val pickup_drive_time: StringResource = StringResource(key = "pickup_drive_time",
        loader = stringsLoader)

    public actual val enable_location_for_travel_time: StringResource = StringResource(key =
        "enable_location_for_travel_time", loader = stringsLoader)

    public actual val sold_out: StringResource = StringResource(key = "sold_out", loader =
        stringsLoader)

    public actual val no_active_reservations_yet: StringResource = StringResource(key =
        "no_active_reservations_yet", loader = stringsLoader)

    public actual val find_bag: StringResource = StringResource(key = "find_bag", loader =
        stringsLoader)

    public actual val my_reservations: StringResource = StringResource(key = "my_reservations",
        loader = stringsLoader)

    public actual val tab_active: StringResource = StringResource(key = "tab_active", loader =
        stringsLoader)

    public actual val tab_inactive: StringResource = StringResource(key = "tab_inactive", loader =
        stringsLoader)

    public actual val tab_history: StringResource = StringResource(key = "tab_history", loader =
        stringsLoader)

    public actual val swipe_to_confirm_collection: StringResource = StringResource(key =
        "swipe_to_confirm_collection", loader = stringsLoader)

    public actual val pickup_address: StringResource = StringResource(key = "pickup_address", loader
        = stringsLoader)

    public actual val collection_time_window: StringResource = StringResource(key =
        "collection_time_window", loader = stringsLoader)

    public actual val amount: StringResource = StringResource(key = "amount", loader =
        stringsLoader)

    public actual val leave_review: StringResource = StringResource(key = "leave_review", loader =
        stringsLoader)

    public actual val how_was_your_experience: StringResource = StringResource(key =
        "how_was_your_experience", loader = stringsLoader)

    public actual val could_be_better_optional: StringResource = StringResource(key =
        "could_be_better_optional", loader = stringsLoader)

    public actual val review_could_better_price: StringResource = StringResource(key =
        "review_could_better_price", loader = stringsLoader)

    public actual val review_could_better_pickup_time: StringResource = StringResource(key =
        "review_could_better_pickup_time", loader = stringsLoader)

    public actual val review_could_better_bag_variety: StringResource = StringResource(key =
        "review_could_better_bag_variety", loader = stringsLoader)

    public actual val review_could_better_packaging: StringResource = StringResource(key =
        "review_could_better_packaging", loader = stringsLoader)

    public actual val review_could_better_staff_attitude: StringResource = StringResource(key =
        "review_could_better_staff_attitude", loader = stringsLoader)

    public actual val add_comment: StringResource = StringResource(key = "add_comment", loader =
        stringsLoader)

    public actual val released_reservations: StringResource = StringResource(key =
        "released_reservations", loader = stringsLoader)

    public actual val mark_as_delivered: StringResource = StringResource(key = "mark_as_delivered",
        loader = stringsLoader)

    public actual val review_rating_freshness: StringResource = StringResource(key =
        "review_rating_freshness", loader = stringsLoader)

    public actual val review_rating_quality: StringResource = StringResource(key =
        "review_rating_quality", loader = stringsLoader)

    public actual val review_rating_variety: StringResource = StringResource(key =
        "review_rating_variety", loader = stringsLoader)

    public actual val review_rating_value: StringResource = StringResource(key =
        "review_rating_value", loader = stringsLoader)

    public actual val review_rating_taste: StringResource = StringResource(key =
        "review_rating_taste", loader = stringsLoader)

    public actual val review_rating_presentation: StringResource = StringResource(key =
        "review_rating_presentation", loader = stringsLoader)

    public actual val review_rating_portion_size: StringResource = StringResource(key =
        "review_rating_portion_size", loader = stringsLoader)

    public actual val review_rating_coffee_quality: StringResource = StringResource(key =
        "review_rating_coffee_quality", loader = stringsLoader)

    public actual val review_rating_service: StringResource = StringResource(key =
        "review_rating_service", loader = stringsLoader)

    public actual val review_rating_atmosphere: StringResource = StringResource(key =
        "review_rating_atmosphere", loader = stringsLoader)

    public actual val review_rating_product_quality: StringResource = StringResource(key =
        "review_rating_product_quality", loader = stringsLoader)

    public actual val review_rating_packaging: StringResource = StringResource(key =
        "review_rating_packaging", loader = stringsLoader)

    public actual val review_rating_service_quality: StringResource = StringResource(key =
        "review_rating_service_quality", loader = stringsLoader)

    public actual val review_rating_professionalism: StringResource = StringResource(key =
        "review_rating_professionalism", loader = stringsLoader)

    public actual val review_rating_hygiene: StringResource = StringResource(key =
        "review_rating_hygiene", loader = stringsLoader)

    public actual val review_rating_service_speed: StringResource = StringResource(key =
        "review_rating_service_speed", loader = stringsLoader)

    public actual val review_rating_price: StringResource = StringResource(key =
        "review_rating_price", loader = stringsLoader)

    public actual val review_rating_accessibility: StringResource = StringResource(key =
        "review_rating_accessibility", loader = stringsLoader)

    public actual val review_rating_effectiveness: StringResource = StringResource(key =
        "review_rating_effectiveness", loader = stringsLoader)

    public actual val review_rating_service_consultation: StringResource = StringResource(key =
        "review_rating_service_consultation", loader = stringsLoader)

    public actual val review_rating_packaging_transport: StringResource = StringResource(key =
        "review_rating_packaging_transport", loader = stringsLoader)

    public actual val login_as_merchant: StringResource = StringResource(key = "login_as_merchant",
        loader = stringsLoader)

    public actual val sign_in: StringResource = StringResource(key = "sign_in", loader =
        stringsLoader)

    public actual val sign_in_title: StringResource = StringResource(key = "sign_in_title", loader =
        stringsLoader)

    public actual val dont_have_account: StringResource = StringResource(key = "dont_have_account",
        loader = stringsLoader)

    public actual val forgot_password_question: StringResource = StringResource(key =
        "forgot_password_question", loader = stringsLoader)

    public actual val login_as_staff: StringResource = StringResource(key = "login_as_staff", loader
        = stringsLoader)

    public actual val what_kind_of_user_are_you: StringResource = StringResource(key =
        "what_kind_of_user_are_you", loader = stringsLoader)

    public actual val client: StringResource = StringResource(key = "client", loader =
        stringsLoader)

    public actual val merchant: StringResource = StringResource(key = "merchant", loader =
        stringsLoader)

    public actual val continue_as_merchant: StringResource = StringResource(key =
        "continue_as_merchant", loader = stringsLoader)

    public actual val continue_with_facebook: StringResource = StringResource(key =
        "continue_with_facebook", loader = stringsLoader)

    public actual val continue_with_email: StringResource = StringResource(key =
        "continue_with_email", loader = stringsLoader)

    public actual val continue_with_google: StringResource = StringResource(key =
        "continue_with_google", loader = stringsLoader)

    public actual val continue_with_apple: StringResource = StringResource(key =
        "continue_with_apple", loader = stringsLoader)

    public actual val registration: StringResource = StringResource(key = "registration", loader =
        stringsLoader)

    public actual val login_securely_and_faster: StringResource = StringResource(key =
        "login_securely_and_faster", loader = stringsLoader)

    public actual val enable_biometric_description: StringResource = StringResource(key =
        "enable_biometric_description", loader = stringsLoader)

    public actual val skip_for_now: StringResource = StringResource(key = "skip_for_now", loader =
        stringsLoader)

    public actual val set_up: StringResource = StringResource(key = "set_up", loader =
        stringsLoader)

    public actual val company_details: StringResource = StringResource(key = "company_details",
        loader = stringsLoader)

    public actual val company_identifier: StringResource = StringResource(key =
        "company_identifier", loader = stringsLoader)

    public actual val your_mobile_number: StringResource = StringResource(key =
        "your_mobile_number", loader = stringsLoader)

    public actual val terms_agreement_prefix: StringResource = StringResource(key =
        "terms_agreement_prefix", loader = stringsLoader)

    public actual val general_terms_mystybag: StringResource = StringResource(key =
        "general_terms_mystybag", loader = stringsLoader)

    public actual val terms_agreement_and: StringResource = StringResource(key =
        "terms_agreement_and", loader = stringsLoader)

    public actual val set_new_password: StringResource = StringResource(key = "set_new_password",
        loader = stringsLoader)

    public actual val staff: StringResource = StringResource(key = "staff", loader = stringsLoader)

    public actual val add_employee: StringResource = StringResource(key = "add_employee", loader =
        stringsLoader)

    public actual val edit_employee: StringResource = StringResource(key = "edit_employee", loader =
        stringsLoader)

    public actual val no_staff: StringResource = StringResource(key = "no_staff", loader =
        stringsLoader)

    public actual val role_staff: StringResource = StringResource(key = "role_staff", loader =
        stringsLoader)

    public actual val role_manager: StringResource = StringResource(key = "role_manager", loader =
        stringsLoader)

    public actual val role_owner: StringResource = StringResource(key = "role_owner", loader =
        stringsLoader)

    public actual val employee_added_successfully: StringResource = StringResource(key =
        "employee_added_successfully", loader = stringsLoader)

    public actual val employee_updated_successfully: StringResource = StringResource(key =
        "employee_updated_successfully", loader = stringsLoader)

    public actual val permissions: StringResource = StringResource(key = "permissions", loader =
        stringsLoader)

    public actual val permission_can_create_bags: StringResource = StringResource(key =
        "permission_can_create_bags", loader = stringsLoader)

    public actual val permission_can_view_revenue: StringResource = StringResource(key =
        "permission_can_view_revenue", loader = stringsLoader)

    public actual val add_your_login_details: StringResource = StringResource(key =
        "add_your_login_details", loader = stringsLoader)

    public actual val login_details_description: StringResource = StringResource(key =
        "login_details_description", loader = stringsLoader)

    public actual val company_name: StringResource = StringResource(key = "company_name", loader =
        stringsLoader)

    public actual val please_enter_company_name: StringResource = StringResource(key =
        "please_enter_company_name", loader = stringsLoader)

    public actual val company_logo: StringResource = StringResource(key = "company_logo", loader =
        stringsLoader)

    public actual val company_street: StringResource = StringResource(key = "company_street", loader
        = stringsLoader)

    public actual val merchant_profile: StringResource = StringResource(key = "merchant_profile",
        loader = stringsLoader)

    public actual val category: StringResource = StringResource(key = "category", loader =
        stringsLoader)

    public actual val select_store_type: StringResource = StringResource(key = "select_store_type",
        loader = stringsLoader)

    public actual val add_your_merchant_location_details: StringResource = StringResource(key =
        "add_your_merchant_location_details", loader = stringsLoader)

    public actual val add_merchant_location_title: StringResource = StringResource(key =
        "add_merchant_location_title", loader = stringsLoader)

    public actual val add_store_screen_title: StringResource = StringResource(key =
        "add_store_screen_title", loader = stringsLoader)

    public actual val add_location_products_hint: StringResource = StringResource(key =
        "add_location_products_hint", loader = stringsLoader)

    public actual val products_added_after_save: StringResource = StringResource(key =
        "products_added_after_save", loader = stringsLoader)

    public actual val grams_with_unit: StringResource = StringResource(key = "grams_with_unit",
        loader = stringsLoader)

    public actual val allergens_section_optional: StringResource = StringResource(key =
        "allergens_section_optional", loader = stringsLoader)

    public actual val menu_section_optional: StringResource = StringResource(key =
        "menu_section_optional", loader = stringsLoader)

    public actual val edit_merchant_location_title: StringResource = StringResource(key =
        "edit_merchant_location_title", loader = stringsLoader)

    public actual val location_cover_photo: StringResource = StringResource(key =
        "location_cover_photo", loader = stringsLoader)

    public actual val add_location_cover_photo: StringResource = StringResource(key =
        "add_location_cover_photo", loader = stringsLoader)

    public actual val menu_photos: StringResource = StringResource(key = "menu_photos", loader =
        stringsLoader)

    public actual val menu_section_header: StringResource = StringResource(key =
        "menu_section_header", loader = stringsLoader)

    public actual val add_menu_photo: StringResource = StringResource(key = "add_menu_photo", loader
        = stringsLoader)

    public actual val menu_photos_up_to_10: StringResource = StringResource(key =
        "menu_photos_up_to_10", loader = stringsLoader)

    public actual val store_name: StringResource = StringResource(key = "store_name", loader =
        stringsLoader)

    public actual val store_details_section: StringResource = StringResource(key =
        "store_details_section", loader = stringsLoader)

    public actual val confirm_location: StringResource = StringResource(key = "confirm_location",
        loader = stringsLoader)

    public actual val tab_location_short: StringResource = StringResource(key =
        "tab_location_short", loader = stringsLoader)

    public actual val street_name_and_number: StringResource = StringResource(key =
        "street_name_and_number", loader = stringsLoader)

    public actual val city: StringResource = StringResource(key = "city", loader = stringsLoader)

    public actual val country: StringResource = StringResource(key = "country", loader =
        stringsLoader)

    public actual val dial_code: StringResource = StringResource(key = "dial_code", loader =
        stringsLoader)

    public actual val phone_number_label: StringResource = StringResource(key =
        "phone_number_label", loader = stringsLoader)

    public actual val location_phone_number: StringResource = StringResource(key =
        "location_phone_number", loader = stringsLoader)

    public actual val contact_number: StringResource = StringResource(key = "contact_number", loader
        = stringsLoader)

    public actual val packaging: StringResource = StringResource(key = "packaging", loader =
        stringsLoader)

    public actual val additional_instructions_pickup: StringResource = StringResource(key =
        "additional_instructions_pickup", loader = stringsLoader)

    public actual val surprise_bag_contains_buffet_food: StringResource = StringResource(key =
        "surprise_bag_contains_buffet_food", loader = stringsLoader)

    public actual val bag_contains_products_for_persons_over_18: StringResource = StringResource(key
        = "bag_contains_products_for_persons_over_18", loader = stringsLoader)

    public actual val bag_adult_products_disclosure: StringResource = StringResource(key =
        "bag_adult_products_disclosure", loader = stringsLoader)

    public actual val characters_count: StringResource = StringResource(key = "characters_count",
        loader = stringsLoader)

    public actual val add_your_company_details: StringResource = StringResource(key =
        "add_your_company_details", loader = stringsLoader)

    public actual val first_name_label: StringResource = StringResource(key = "first_name_label",
        loader = stringsLoader)

    public actual val last_name_label: StringResource = StringResource(key = "last_name_label",
        loader = stringsLoader)

    public actual val legal_entity_name: StringResource = StringResource(key = "legal_entity_name",
        loader = stringsLoader)

    public actual val bulstat: StringResource = StringResource(key = "bulstat", loader =
        stringsLoader)

    public actual val bulstat_required: StringResource = StringResource(key = "bulstat_required",
        loader = stringsLoader)

    public actual val bulstat_invalid_format: StringResource = StringResource(key =
        "bulstat_invalid_format", loader = stringsLoader)

    public actual val bulstat_invalid_length: StringResource = StringResource(key =
        "bulstat_invalid_length", loader = stringsLoader)

    public actual val merchant_with_this_bulstat_exists: StringResource = StringResource(key =
        "merchant_with_this_bulstat_exists", loader = stringsLoader)

    public actual val company_book_lookup_failed: StringResource = StringResource(key =
        "company_book_lookup_failed", loader = stringsLoader)

    public actual val privacy_policy: StringResource = StringResource(key = "privacy_policy", loader
        = stringsLoader)

    public actual val terms_and_conditions: StringResource = StringResource(key =
        "terms_and_conditions", loader = stringsLoader)

    public actual val password: StringResource = StringResource(key = "password", loader =
        stringsLoader)

    public actual val confirm_password: StringResource = StringResource(key = "confirm_password",
        loader = stringsLoader)

    public actual val passwords_do_not_match: StringResource = StringResource(key =
        "passwords_do_not_match", loader = stringsLoader)

    public actual val at_least_8_characters: StringResource = StringResource(key =
        "at_least_8_characters", loader = stringsLoader)

    public actual val at_least_1_number: StringResource = StringResource(key = "at_least_1_number",
        loader = stringsLoader)

    public actual val at_least_1_letter: StringResource = StringResource(key = "at_least_1_letter",
        loader = stringsLoader)

    public actual val registered_company_address: StringResource = StringResource(key =
        "registered_company_address", loader = stringsLoader)

    public actual val add: StringResource = StringResource(key = "add", loader = stringsLoader)

    public actual val details: StringResource = StringResource(key = "details", loader =
        stringsLoader)

    public actual val add_another_mol: StringResource = StringResource(key = "add_another_mol",
        loader = stringsLoader)

    public actual val add_mol: StringResource = StringResource(key = "add_mol", loader =
        stringsLoader)

    public actual val mol: StringResource = StringResource(key = "mol", loader = stringsLoader)

    public actual val delete_mol_confirmation_title: StringResource = StringResource(key =
        "delete_mol_confirmation_title", loader = stringsLoader)

    public actual val delete_mol_confirmation_message: StringResource = StringResource(key =
        "delete_mol_confirmation_message", loader = stringsLoader)

    public actual val set_weekly_pickup_schedule: StringResource = StringResource(key =
        "set_weekly_pickup_schedule", loader = stringsLoader)

    public actual val pickup_schedule_description: StringResource = StringResource(key =
        "pickup_schedule_description", loader = stringsLoader)

    public actual val name_and_description_description: StringResource = StringResource(key =
        "name_and_description_description", loader = stringsLoader)

    public actual val add_product_description: StringResource = StringResource(key =
        "add_product_description", loader = stringsLoader)

    public actual val add_product_item: StringResource = StringResource(key = "add_product_item",
        loader = stringsLoader)

    public actual val choose_business_image: StringResource = StringResource(key =
        "choose_business_image", loader = stringsLoader)

    public actual val please_select_business_cover_image: StringResource = StringResource(key =
        "please_select_business_cover_image", loader = stringsLoader)

    public actual val describe_your_products: StringResource = StringResource(key =
        "describe_your_products", loader = stringsLoader)

    public actual val product_name: StringResource = StringResource(key = "product_name", loader =
        stringsLoader)

    public actual val grams: StringResource = StringResource(key = "grams", loader = stringsLoader)

    public actual val check_your_inbox: StringResource = StringResource(key = "check_your_inbox",
        loader = stringsLoader)

    public actual val confirm_email_address_title: StringResource = StringResource(key =
        "confirm_email_address_title", loader = stringsLoader)

    public actual val confirm_email_code_sent: StringResource = StringResource(key =
        "confirm_email_code_sent", loader = stringsLoader)

    public actual val check_inbox_email_sent: StringResource = StringResource(key =
        "check_inbox_email_sent", loader = stringsLoader)

    public actual val check_inbox_description: StringResource = StringResource(key =
        "check_inbox_description", loader = stringsLoader)

    public actual val check_inbox_description_2: StringResource = StringResource(key =
        "check_inbox_description_2", loader = stringsLoader)

    public actual val check_inbox_description_3: StringResource = StringResource(key =
        "check_inbox_description_3", loader = stringsLoader)

    public actual val check_inbox_spam_info: StringResource = StringResource(key =
        "check_inbox_spam_info", loader = stringsLoader)

    public actual val verification_code_title: StringResource = StringResource(key =
        "verification_code_title", loader = stringsLoader)

    public actual val verification_code_email_sent_description: StringResource = StringResource(key
        = "verification_code_email_sent_description", loader = stringsLoader)

    public actual val enter_verification_code: StringResource = StringResource(key =
        "enter_verification_code", loader = stringsLoader)

    public actual val merchant_registration_phone_sms_sent: StringResource = StringResource(key =
        "merchant_registration_phone_sms_sent", loader = stringsLoader)

    public actual val sms_verification_code_label: StringResource = StringResource(key =
        "sms_verification_code_label", loader = stringsLoader)

    public actual val resend_sms_code: StringResource = StringResource(key = "resend_sms_code",
        loader = stringsLoader)

    public actual val sms_resend_cooldown_seconds: StringResource = StringResource(key =
        "sms_resend_cooldown_seconds", loader = stringsLoader)

    public actual val save: StringResource = StringResource(key = "save", loader = stringsLoader)

    public actual val payment_data: StringResource = StringResource(key = "payment_data", loader =
        stringsLoader)

    public actual val payment_data_description: StringResource = StringResource(key =
        "payment_data_description", loader = stringsLoader)

    public actual val iban: StringResource = StringResource(key = "iban", loader = stringsLoader)

    public actual val invalid_iban: StringResource = StringResource(key = "invalid_iban", loader =
        stringsLoader)

    public actual val payment_provider_title: StringResource = StringResource(key =
        "payment_provider_title", loader = stringsLoader)

    public actual val payment_provider_mypos: StringResource = StringResource(key =
        "payment_provider_mypos", loader = stringsLoader)

    public actual val payment_provider_stripe: StringResource = StringResource(key =
        "payment_provider_stripe", loader = stringsLoader)

    public actual val stripe_onboarding_banner_title: StringResource = StringResource(key =
        "stripe_onboarding_banner_title", loader = stringsLoader)

    public actual val stripe_onboarding_banner_message: StringResource = StringResource(key =
        "stripe_onboarding_banner_message", loader = stringsLoader)

    public actual val stripe_onboarding_continue: StringResource = StringResource(key =
        "stripe_onboarding_continue", loader = stringsLoader)

    public actual val stripe_onboarding_completed: StringResource = StringResource(key =
        "stripe_onboarding_completed", loader = stringsLoader)

    public actual val merchant_with_this_iban_exists: StringResource = StringResource(key =
        "merchant_with_this_iban_exists", loader = stringsLoader)

    public actual val add_bag: StringResource = StringResource(key = "add_bag", loader =
        stringsLoader)

    public actual val edit_bag: StringResource = StringResource(key = "edit_bag", loader =
        stringsLoader)

    public actual val add_first_bag: StringResource = StringResource(key = "add_first_bag", loader =
        stringsLoader)

    public actual val add_first_bag_message: StringResource = StringResource(key =
        "add_first_bag_message", loader = stringsLoader)

    public actual val start_adding_bag: StringResource = StringResource(key = "start_adding_bag",
        loader = stringsLoader)

    public actual val bags: StringResource = StringResource(key = "bags", loader = stringsLoader)

    public actual val bag: StringResource = StringResource(key = "bag", loader = stringsLoader)

    public actual val reputation: StringResource = StringResource(key = "reputation", loader =
        stringsLoader)

    public actual val objects: StringResource = StringResource(key = "objects", loader =
        stringsLoader)

    public actual val no_bags_found: StringResource = StringResource(key = "no_bags_found", loader =
        stringsLoader)

    public actual val merchant_bag_depleted_still_active: StringResource = StringResource(key =
        "merchant_bag_depleted_still_active", loader = stringsLoader)

    public actual val no_ratings_found: StringResource = StringResource(key = "no_ratings_found",
        loader = stringsLoader)

    public actual val all: StringResource = StringResource(key = "all", loader = stringsLoader)

    public actual val selected: StringResource = StringResource(key = "selected", loader =
        stringsLoader)

    public actual val overall_rating: StringResource = StringResource(key = "overall_rating", loader
        = stringsLoader)

    public actual val select_business_category: StringResource = StringResource(key =
        "select_business_category", loader = stringsLoader)

    public actual val select_city: StringResource = StringResource(key = "select_city", loader =
        stringsLoader)

    public actual val please_select_city: StringResource = StringResource(key =
        "please_select_city", loader = stringsLoader)

    public actual val city_select_description: StringResource = StringResource(key =
        "city_select_description", loader = stringsLoader)

    public actual val search_city: StringResource = StringResource(key = "search_city", loader =
        stringsLoader)

    public actual val no_cities_found: StringResource = StringResource(key = "no_cities_found",
        loader = stringsLoader)

    public actual val select_country: StringResource = StringResource(key = "select_country", loader
        = stringsLoader)

    public actual val search_country: StringResource = StringResource(key = "search_country", loader
        = stringsLoader)

    public actual val favorites_colon: StringResource = StringResource(key = "favorites_colon",
        loader = stringsLoader)

    public actual val review_count_colon: StringResource = StringResource(key =
        "review_count_colon", loader = stringsLoader)

    public actual val pickup_until: StringResource = StringResource(key = "pickup_until", loader =
        stringsLoader)

    public actual val available_colon: StringResource = StringResource(key = "available_colon",
        loader = stringsLoader)

    public actual val reserved_colon: StringResource = StringResource(key = "reserved_colon", loader
        = stringsLoader)

    public actual val total_colon: StringResource = StringResource(key = "total_colon", loader =
        stringsLoader)

    public actual val created_on_colon: StringResource = StringResource(key = "created_on_colon",
        loader = stringsLoader)

    public actual val store_colon: StringResource = StringResource(key = "store_colon", loader =
        stringsLoader)

    public actual val price_colon: StringResource = StringResource(key = "price_colon", loader =
        stringsLoader)

    public actual val available_bags_colon: StringResource = StringResource(key =
        "available_bags_colon", loader = stringsLoader)

    public actual val normal_price_colon: StringResource = StringResource(key =
        "normal_price_colon", loader = stringsLoader)

    public actual val discount_price_colon: StringResource = StringResource(key =
        "discount_price_colon", loader = stringsLoader)

    public actual val average_rating_colon: StringResource = StringResource(key =
        "average_rating_colon", loader = stringsLoader)

    public actual val active_from: StringResource = StringResource(key = "active_from", loader =
        stringsLoader)

    public actual val active_to: StringResource = StringResource(key = "active_to", loader =
        stringsLoader)

    public actual val bag_is_active: StringResource = StringResource(key = "bag_is_active", loader =
        stringsLoader)

    public actual val active_short: StringResource = StringResource(key = "active_short", loader =
        stringsLoader)

    public actual val active_to_must_be_after_active_from: StringResource = StringResource(key =
        "active_to_must_be_after_active_from", loader = stringsLoader)

    public actual val price_normal: StringResource = StringResource(key = "price_normal", loader =
        stringsLoader)

    public actual val price_with_discount: StringResource = StringResource(key =
        "price_with_discount", loader = stringsLoader)

    public actual val optional: StringResource = StringResource(key = "optional", loader =
        stringsLoader)

    public actual val discount_percentage: StringResource = StringResource(key =
        "discount_percentage", loader = stringsLoader)

    public actual val amount_min_error: StringResource = StringResource(key = "amount_min_error",
        loader = stringsLoader)

    public actual val amount_max_error: StringResource = StringResource(key = "amount_max_error",
        loader = stringsLoader)

    public actual val view_active_bags: StringResource = StringResource(key = "view_active_bags",
        loader = stringsLoader)

    public actual val view_all_offers: StringResource = StringResource(key = "view_all_offers",
        loader = stringsLoader)

    public actual val view_all_offers_from: StringResource = StringResource(key =
        "view_all_offers_from", loader = stringsLoader)

    public actual val select_location: StringResource = StringResource(key = "select_location",
        loader = stringsLoader)

    public actual val bag_title: StringResource = StringResource(key = "bag_title", loader =
        stringsLoader)

    public actual val distance: StringResource = StringResource(key = "distance", loader =
        stringsLoader)

    public actual val create: StringResource = StringResource(key = "create", loader =
        stringsLoader)

    public actual val active_bags_count: StringResource = StringResource(key = "active_bags_count",
        loader = stringsLoader)

    public actual val price_range_from_to: StringResource = StringResource(key =
        "price_range_from_to", loader = stringsLoader)

    public actual val price_range_single: StringResource = StringResource(key =
        "price_range_single", loader = stringsLoader)

    public actual val sold_bags: StringResource = StringResource(key = "sold_bags", loader =
        stringsLoader)

    public actual val revenue: StringResource = StringResource(key = "revenue", loader =
        stringsLoader)

    public actual val unpaid_paid: StringResource = StringResource(key = "unpaid_paid", loader =
        stringsLoader)

    public actual val sales_by_day: StringResource = StringResource(key = "sales_by_day", loader =
        stringsLoader)

    public actual val breakdown_by_location: StringResource = StringResource(key =
        "breakdown_by_location", loader = stringsLoader)

    public actual val sales: StringResource = StringResource(key = "sales", loader = stringsLoader)

    public actual val last_7_days: StringResource = StringResource(key = "last_7_days", loader =
        stringsLoader)

    public actual val last_30_days: StringResource = StringResource(key = "last_30_days", loader =
        stringsLoader)

    public actual val custom_period: StringResource = StringResource(key = "custom_period", loader =
        stringsLoader)

    public actual val select_day: StringResource = StringResource(key = "select_day", loader =
        stringsLoader)

    public actual val select_month: StringResource = StringResource(key = "select_month", loader =
        stringsLoader)

    public actual val select_period: StringResource = StringResource(key = "select_period", loader =
        stringsLoader)

    public actual val start_date: StringResource = StringResource(key = "start_date", loader =
        stringsLoader)

    public actual val end_date: StringResource = StringResource(key = "end_date", loader =
        stringsLoader)

    public actual val all_locations: StringResource = StringResource(key = "all_locations", loader =
        stringsLoader)

    public actual val filter_by_location: StringResource = StringResource(key =
        "filter_by_location", loader = stringsLoader)

    public actual val week: StringResource = StringResource(key = "week", loader = stringsLoader)

    public actual val last_week: StringResource = StringResource(key = "last_week", loader =
        stringsLoader)

    public actual val last_month: StringResource = StringResource(key = "last_month", loader =
        stringsLoader)

    public actual val month: StringResource = StringResource(key = "month", loader = stringsLoader)

    public actual val no_sales_data_for_period: StringResource = StringResource(key =
        "no_sales_data_for_period", loader = stringsLoader)

    public actual val no_locations_found: StringResource = StringResource(key =
        "no_locations_found", loader = stringsLoader)

    public actual val overview: StringResource = StringResource(key = "overview", loader =
        stringsLoader)

    public actual val all_time: StringResource = StringResource(key = "all_time", loader =
        stringsLoader)

    public actual val total_sold: StringResource = StringResource(key = "total_sold", loader =
        stringsLoader)

    public actual val paid: StringResource = StringResource(key = "paid", loader = stringsLoader)

    public actual val unpaid: StringResource = StringResource(key = "unpaid", loader =
        stringsLoader)

    public actual val not_accepted: StringResource = StringResource(key = "not_accepted", loader =
        stringsLoader)

    public actual val reviews_section: StringResource = StringResource(key = "reviews_section",
        loader = stringsLoader)

    public actual val avg_rating: StringResource = StringResource(key = "avg_rating", loader =
        stringsLoader)

    public actual val category_name: StringResource = StringResource(key = "category_name", loader =
        stringsLoader)

    public actual val account_settings: StringResource = StringResource(key = "account_settings",
        loader = stringsLoader)

    public actual val collected: StringResource = StringResource(key = "collected", loader =
        stringsLoader)

    public actual val all_reservations: StringResource = StringResource(key = "all_reservations",
        loader = stringsLoader)

    public actual val declined: StringResource = StringResource(key = "declined", loader =
        stringsLoader)

    public actual val for_handover: StringResource = StringResource(key = "for_handover", loader =
        stringsLoader)

    public actual val sold_bags_units: StringResource = StringResource(key = "sold_bags_units",
        loader = stringsLoader)

    public actual val finance: StringResource = StringResource(key = "finance", loader =
        stringsLoader)

    public actual val statements: StringResource = StringResource(key = "statements", loader =
        stringsLoader)

    public actual val statements_from: StringResource = StringResource(key = "statements_from",
        loader = stringsLoader)

    public actual val statements_to: StringResource = StringResource(key = "statements_to", loader =
        stringsLoader)

    public actual val statements_selected_period: StringResource = StringResource(key =
        "statements_selected_period", loader = stringsLoader)

    public actual val statements_total_amount: StringResource = StringResource(key =
        "statements_total_amount", loader = stringsLoader)

    public actual val statements_share: StringResource = StringResource(key = "statements_share",
        loader = stringsLoader)

    public actual val statements_period_label: StringResource = StringResource(key =
        "statements_period_label", loader = stringsLoader)

    public actual val statements_totals_header: StringResource = StringResource(key =
        "statements_totals_header", loader = stringsLoader)

    public actual val statements_column_bag_name: StringResource = StringResource(key =
        "statements_column_bag_name", loader = stringsLoader)

    public actual val statements_column_sale_date: StringResource = StringResource(key =
        "statements_column_sale_date", loader = stringsLoader)

    public actual val statements_column_amount: StringResource = StringResource(key =
        "statements_column_amount", loader = stringsLoader)

    public actual val statements_column_transaction_ref: StringResource = StringResource(key =
        "statements_column_transaction_ref", loader = stringsLoader)

    public actual val statements_column_discounted_amount: StringResource = StringResource(key =
        "statements_column_discounted_amount", loader = stringsLoader)

    public actual val statements_column_currency: StringResource = StringResource(key =
        "statements_column_currency", loader = stringsLoader)

    public actual val statements_column_withheld: StringResource = StringResource(key =
        "statements_column_withheld", loader = stringsLoader)

    public actual val statements_column_withheld_currency: StringResource = StringResource(key =
        "statements_column_withheld_currency", loader = stringsLoader)

    public actual val statements_no_rows: StringResource = StringResource(key =
        "statements_no_rows", loader = stringsLoader)

    public actual val currency_eur: StringResource = StringResource(key = "currency_eur", loader =
        stringsLoader)

    public actual val bank_account: StringResource = StringResource(key = "bank_account", loader =
        stringsLoader)

    public actual val business: StringResource = StringResource(key = "business", loader =
        stringsLoader)

    public actual val business_details: StringResource = StringResource(key = "business_details",
        loader = stringsLoader)

    public actual val object_screen_title: StringResource = StringResource(key =
        "object_screen_title", loader = stringsLoader)

    public actual val merchant_locations: StringResource = StringResource(key =
        "merchant_locations", loader = stringsLoader)

    public actual val select_at_least_one_location: StringResource = StringResource(key =
        "select_at_least_one_location", loader = stringsLoader)

    public actual val add_location: StringResource = StringResource(key = "add_location", loader =
        stringsLoader)

    public actual val rating_label: StringResource = StringResource(key = "rating_label", loader =
        stringsLoader)

    public actual val location_label: StringResource = StringResource(key = "location_label", loader
        = stringsLoader)

    public actual val employees_label: StringResource = StringResource(key = "employees_label",
        loader = stringsLoader)

    public actual val active_bags_label: StringResource = StringResource(key = "active_bags_label",
        loader = stringsLoader)

    public actual val pickup_schedules: StringResource = StringResource(key = "pickup_schedules",
        loader = stringsLoader)

    public actual val collect_time: StringResource = StringResource(key = "collect_time", loader =
        stringsLoader)

    public actual val bag_details: StringResource = StringResource(key = "bag_details", loader =
        stringsLoader)

    public actual val view_pickup_schedules: StringResource = StringResource(key =
        "view_pickup_schedules", loader = stringsLoader)

    public actual val time_from: StringResource = StringResource(key = "time_from", loader =
        stringsLoader)

    public actual val time_to: StringResource = StringResource(key = "time_to", loader =
        stringsLoader)

    public actual val handover_from: StringResource = StringResource(key = "handover_from", loader =
        stringsLoader)

    public actual val handover_to: StringResource = StringResource(key = "handover_to", loader =
        stringsLoader)

    public actual val please_enter_all_required_fields: StringResource = StringResource(key =
        "please_enter_all_required_fields", loader = stringsLoader)

    public actual val save_all: StringResource = StringResource(key = "save_all", loader =
        stringsLoader)

    public actual val pickup_schedule_saved_successfully: StringResource = StringResource(key =
        "pickup_schedule_saved_successfully", loader = stringsLoader)

    public actual val invalid_pickup_time_range: StringResource = StringResource(key =
        "invalid_pickup_time_range", loader = stringsLoader)

    public actual val add_delivery_slot: StringResource = StringResource(key = "add_delivery_slot",
        loader = stringsLoader)

    public actual val remove_slot: StringResource = StringResource(key = "remove_slot", loader =
        stringsLoader)

    public actual val contacts: StringResource = StringResource(key = "contacts", loader =
        stringsLoader)

    public actual val contacts_persons: StringResource = StringResource(key = "contacts_persons",
        loader = stringsLoader)

    public actual val company_responsible_persons: StringResource = StringResource(key =
        "company_responsible_persons", loader = stringsLoader)

    public actual val confirmed_on: StringResource = StringResource(key = "confirmed_on", loader =
        stringsLoader)

    public actual val pending_confirmation: StringResource = StringResource(key =
        "pending_confirmation", loader = stringsLoader)

    public actual val no_iban_set: StringResource = StringResource(key = "no_iban_set", loader =
        stringsLoader)

    public actual val no_responsible_persons: StringResource = StringResource(key =
        "no_responsible_persons", loader = stringsLoader)

    public actual val responsible_person_updated_successfully: StringResource = StringResource(key =
        "responsible_person_updated_successfully", loader = stringsLoader)

    public actual val responsible_person_details: StringResource = StringResource(key =
        "responsible_person_details", loader = stringsLoader)

    public actual val merchant_registration_success: StringResource = StringResource(key =
        "merchant_registration_success", loader = stringsLoader)

    public actual val merchant_registration_success_message: StringResource = StringResource(key =
        "merchant_registration_success_message", loader = stringsLoader)

    public actual val merchant_registration_under_review_title: StringResource = StringResource(key
        = "merchant_registration_under_review_title", loader = stringsLoader)

    public actual val merchant_registration_under_review_message: StringResource =
        StringResource(key = "merchant_registration_under_review_message", loader = stringsLoader)

    public actual val proceed_to_login: StringResource = StringResource(key = "proceed_to_login",
        loader = stringsLoader)

    public actual val add_your_first_location: StringResource = StringResource(key =
        "add_your_first_location", loader = stringsLoader)

    public actual val add_location_prompt_message: StringResource = StringResource(key =
        "add_location_prompt_message", loader = stringsLoader)

    public actual val get_started: StringResource = StringResource(key = "get_started", loader =
        stringsLoader)

    public actual val location_details: StringResource = StringResource(key = "location_details",
        loader = stringsLoader)

    public actual val no_locations: StringResource = StringResource(key = "no_locations", loader =
        stringsLoader)

    public actual val please_enter_location_title: StringResource = StringResource(key =
        "please_enter_location_title", loader = stringsLoader)

    public actual val please_enter_address: StringResource = StringResource(key =
        "please_enter_address", loader = stringsLoader)

    public actual val address: StringResource = StringResource(key = "address", loader =
        stringsLoader)

    public actual val please_enter_phone_number: StringResource = StringResource(key =
        "please_enter_phone_number", loader = stringsLoader)

    public actual val business_category_bakery: StringResource = StringResource(key =
        "business_category_bakery", loader = stringsLoader)

    public actual val business_category_confectionery: StringResource = StringResource(key =
        "business_category_confectionery", loader = stringsLoader)

    public actual val business_category_fish_market: StringResource = StringResource(key =
        "business_category_fish_market", loader = stringsLoader)

    public actual val business_category_food_for_home: StringResource = StringResource(key =
        "business_category_food_for_home", loader = stringsLoader)

    public actual val new_group: StringResource = StringResource(key = "new_group", loader =
        stringsLoader)

    public actual val search_allergen: StringResource = StringResource(key = "search_allergen",
        loader = stringsLoader)

    public actual val allergen_groups: StringResource = StringResource(key = "allergen_groups",
        loader = stringsLoader)

    public actual val allergen_groups_section_description: StringResource = StringResource(key =
        "allergen_groups_section_description", loader = stringsLoader)

    public actual val set_up_allergen_group_to_apply_to_future_bags: StringResource =
        StringResource(key = "set_up_allergen_group_to_apply_to_future_bags", loader =
        stringsLoader)

    public actual val add_new_group: StringResource = StringResource(key = "add_new_group", loader =
        stringsLoader)

    public actual val add_allergen_group: StringResource = StringResource(key =
        "add_allergen_group", loader = stringsLoader)

    public actual val edit_allergen_group: StringResource = StringResource(key =
        "edit_allergen_group", loader = stringsLoader)

    public actual val allergen_group_name: StringResource = StringResource(key =
        "allergen_group_name", loader = stringsLoader)

    public actual val please_enter_group_name: StringResource = StringResource(key =
        "please_enter_group_name", loader = stringsLoader)

    public actual val select_allergens_for_group: StringResource = StringResource(key =
        "select_allergens_for_group", loader = stringsLoader)

    public actual val add_allergens_to_the_group: StringResource = StringResource(key =
        "add_allergens_to_the_group", loader = stringsLoader)

    public actual val no_allergen_groups: StringResource = StringResource(key =
        "no_allergen_groups", loader = stringsLoader)

    public actual val select_allergen_group: StringResource = StringResource(key =
        "select_allergen_group", loader = stringsLoader)

    public actual val add_allergens: StringResource = StringResource(key = "add_allergens", loader =
        stringsLoader)

    public actual val edit_allergens: StringResource = StringResource(key = "edit_allergens", loader
        = stringsLoader)

    public actual val section_allergens: StringResource = StringResource(key = "section_allergens",
        loader = stringsLoader)

    public actual val your_groups: StringResource = StringResource(key = "your_groups", loader =
        stringsLoader)

    public actual val apply_group: StringResource = StringResource(key = "apply_group", loader =
        stringsLoader)

    public actual val delete_allergen_group: StringResource = StringResource(key =
        "delete_allergen_group", loader = stringsLoader)

    public actual val delete_allergen_group_confirmation_title: StringResource = StringResource(key
        = "delete_allergen_group_confirmation_title", loader = stringsLoader)

    public actual val delete_allergen_group_confirmation_message: StringResource =
        StringResource(key = "delete_allergen_group_confirmation_message", loader = stringsLoader)

    public actual val edit_short: StringResource = StringResource(key = "edit_short", loader =
        stringsLoader)

    public actual val deactivate_bag_confirmation_title: StringResource = StringResource(key =
        "deactivate_bag_confirmation_title", loader = stringsLoader)

    public actual val deactivate_bag_confirmation_message: StringResource = StringResource(key =
        "deactivate_bag_confirmation_message", loader = stringsLoader)

    public actual val deactivate_bag_confirm: StringResource = StringResource(key =
        "deactivate_bag_confirm", loader = stringsLoader)

    public actual val deactivate_bag_success: StringResource = StringResource(key =
        "deactivate_bag_success", loader = stringsLoader)

    public actual val menu_details: StringResource = StringResource(key = "menu_details", loader =
        stringsLoader)

    public actual val menu_remove: StringResource = StringResource(key = "menu_remove", loader =
        stringsLoader)

    public actual val clear_allergen_group_selection: StringResource = StringResource(key =
        "clear_allergen_group_selection", loader = stringsLoader)

    public actual val filter_results: StringResource = StringResource(key = "filter_results", loader
        = stringsLoader)

    public actual val reset_filters: StringResource = StringResource(key = "reset_filters", loader =
        stringsLoader)

    public actual val apply: StringResource = StringResource(key = "apply", loader = stringsLoader)

    public actual val pickup_location_distance_from_me: StringResource = StringResource(key =
        "pickup_location_distance_from_me", loader = stringsLoader)

    public actual val use_my_location: StringResource = StringResource(key = "use_my_location",
        loader = stringsLoader)

    public actual val filter_location_select_hint: StringResource = StringResource(key =
        "filter_location_select_hint", loader = stringsLoader)

    public actual val price_range: StringResource = StringResource(key = "price_range", loader =
        stringsLoader)

    public actual val discounted_price_of_the_bag: StringResource = StringResource(key =
        "discounted_price_of_the_bag", loader = stringsLoader)

    public actual val minimum: StringResource = StringResource(key = "minimum", loader =
        stringsLoader)

    public actual val maximum: StringResource = StringResource(key = "maximum", loader =
        stringsLoader)

    public actual val filter_price_max_999: StringResource = StringResource(key =
        "filter_price_max_999", loader = stringsLoader)

    public actual val enter_amount: StringResource = StringResource(key = "enter_amount", loader =
        stringsLoader)

    public actual val merchant_rating: StringResource = StringResource(key = "merchant_rating",
        loader = stringsLoader)

    public actual val offer_published_date: StringResource = StringResource(key =
        "offer_published_date", loader = stringsLoader)

    public actual val collection_time: StringResource = StringResource(key = "collection_time",
        loader = stringsLoader)

    public actual val today: StringResource = StringResource(key = "today", loader = stringsLoader)

    public actual val last_3_days: StringResource = StringResource(key = "last_3_days", loader =
        stringsLoader)

    public actual val this_week: StringResource = StringResource(key = "this_week", loader =
        stringsLoader)

    public actual val this_month: StringResource = StringResource(key = "this_month", loader =
        stringsLoader)

    public actual val available_now: StringResource = StringResource(key = "available_now", loader =
        stringsLoader)

    public actual val evening: StringResource = StringResource(key = "evening", loader =
        stringsLoader)

    public actual val filter_any: StringResource = StringResource(key = "filter_any", loader =
        stringsLoader)

    public actual val allowed: StringResource = StringResource(key = "allowed", loader =
        stringsLoader)

    public actual val not_allowed: StringResource = StringResource(key = "not_allowed", loader =
        stringsLoader)

    public actual val search: StringResource = StringResource(key = "search", loader =
        stringsLoader)

    public actual val section_access_to: StringResource = StringResource(key = "section_access_to",
        loader = stringsLoader)

    public actual val products: StringResource = StringResource(key = "products", loader =
        stringsLoader)

    public actual val bag_products: StringResource = StringResource(key = "bag_products", loader =
        stringsLoader)

    public actual val product_selection_title: StringResource = StringResource(key =
        "product_selection_title", loader = stringsLoader)

    public actual val product_selection_all: StringResource = StringResource(key =
        "product_selection_all", loader = stringsLoader)

    public actual val product_selection_by_category: StringResource = StringResource(key =
        "product_selection_by_category", loader = stringsLoader)

    public actual val product_selection_custom: StringResource = StringResource(key =
        "product_selection_custom", loader = stringsLoader)

    public actual val select_product_category: StringResource = StringResource(key =
        "select_product_category", loader = stringsLoader)

    public actual val product_mode_all_title: StringResource = StringResource(key =
        "product_mode_all_title", loader = stringsLoader)

    public actual val product_mode_all_subtitle: StringResource = StringResource(key =
        "product_mode_all_subtitle", loader = stringsLoader)

    public actual val product_mode_category_title: StringResource = StringResource(key =
        "product_mode_category_title", loader = stringsLoader)

    public actual val product_mode_category_subtitle: StringResource = StringResource(key =
        "product_mode_category_subtitle", loader = stringsLoader)

    public actual val product_mode_custom_title: StringResource = StringResource(key =
        "product_mode_custom_title", loader = stringsLoader)

    public actual val product_mode_custom_subtitle: StringResource = StringResource(key =
        "product_mode_custom_subtitle", loader = stringsLoader)

    public actual val product_all_auto_note: StringResource = StringResource(key =
        "product_all_auto_note", loader = stringsLoader)

    public actual val search_product_hint: StringResource = StringResource(key =
        "search_product_hint", loader = stringsLoader)

    public actual val categories_count_suffix: StringResource = StringResource(key =
        "categories_count_suffix", loader = stringsLoader)

    public actual val selected_products_suffix: StringResource = StringResource(key =
        "selected_products_suffix", loader = stringsLoader)

    public actual val no_products: StringResource = StringResource(key = "no_products", loader =
        stringsLoader)

    public actual val no_product_categories: StringResource = StringResource(key =
        "no_product_categories", loader = stringsLoader)

    public actual val manage_products: StringResource = StringResource(key = "manage_products",
        loader = stringsLoader)

    public actual val manage_product_catalog: StringResource = StringResource(key =
        "manage_product_catalog", loader = stringsLoader)

    public actual val add_product: StringResource = StringResource(key = "add_product", loader =
        stringsLoader)

    public actual val edit_product: StringResource = StringResource(key = "edit_product", loader =
        stringsLoader)

    public actual val add_category: StringResource = StringResource(key = "add_category", loader =
        stringsLoader)

    public actual val edit_category: StringResource = StringResource(key = "edit_category", loader =
        stringsLoader)

    public actual val add_subcategory: StringResource = StringResource(key = "add_subcategory",
        loader = stringsLoader)

    public actual val product_description: StringResource = StringResource(key =
        "product_description", loader = stringsLoader)

    public actual val parent_category: StringResource = StringResource(key = "parent_category",
        loader = stringsLoader)

    public actual val no_parent_category: StringResource = StringResource(key =
        "no_parent_category", loader = stringsLoader)

    public actual val product_category_none: StringResource = StringResource(key =
        "product_category_none", loader = stringsLoader)

    public actual val product_group: StringResource = StringResource(key = "product_group", loader =
        stringsLoader)

    public actual val manage_products_create_group_first: StringResource = StringResource(key =
        "manage_products_create_group_first", loader = stringsLoader)

    public actual val product_category_required: StringResource = StringResource(key =
        "product_category_required", loader = stringsLoader)

    public actual val manage_products_search_hint: StringResource = StringResource(key =
        "manage_products_search_hint", loader = stringsLoader)

    public actual val products_count_suffix: StringResource = StringResource(key =
        "products_count_suffix", loader = stringsLoader)

    public actual val subcategories_count_suffix: StringResource = StringResource(key =
        "subcategories_count_suffix", loader = stringsLoader)

    public actual val product_name_required: StringResource = StringResource(key =
        "product_name_required", loader = stringsLoader)

    public actual val product_category_invalid_parent: StringResource = StringResource(key =
        "product_category_invalid_parent", loader = stringsLoader)

    public actual val product_enabled: StringResource = StringResource(key = "product_enabled",
        loader = stringsLoader)

    public actual val delete_product: StringResource = StringResource(key = "delete_product", loader
        = stringsLoader)

    public actual val delete_product_confirmation_title: StringResource = StringResource(key =
        "delete_product_confirmation_title", loader = stringsLoader)

    public actual val delete_product_confirmation_message: StringResource = StringResource(key =
        "delete_product_confirmation_message", loader = stringsLoader)

    public actual val delete_category: StringResource = StringResource(key = "delete_category",
        loader = stringsLoader)

    public actual val delete_category_confirmation_title: StringResource = StringResource(key =
        "delete_category_confirmation_title", loader = stringsLoader)

    public actual val delete_category_confirmation_message: StringResource = StringResource(key =
        "delete_category_confirmation_message", loader = stringsLoader)

    public actual val products_in_bag_count: StringResource = StringResource(key =
        "products_in_bag_count", loader = stringsLoader)

    public actual val products_section_title: StringResource = StringResource(key =
        "products_section_title", loader = stringsLoader)

    public actual val menu_photos_section_title: StringResource = StringResource(key =
        "menu_photos_section_title", loader = stringsLoader)

    public actual val catalog_no_categories_yet: StringResource = StringResource(key =
        "catalog_no_categories_yet", loader = stringsLoader)

    public actual val catalog_empty_title: StringResource = StringResource(key =
        "catalog_empty_title", loader = stringsLoader)

    public actual val catalog_empty_subtitle: StringResource = StringResource(key =
        "catalog_empty_subtitle", loader = stringsLoader)

    public actual val enter_group_name: StringResource = StringResource(key = "enter_group_name",
        loader = stringsLoader)

    public actual val product_category_label: StringResource = StringResource(key =
        "product_category_label", loader = stringsLoader)

    public actual val product_subcategory_label: StringResource = StringResource(key =
        "product_subcategory_label", loader = stringsLoader)

    public actual val catalog_add_group: StringResource = StringResource(key = "catalog_add_group",
        loader = stringsLoader)

    public actual val catalog_add_subgroup: StringResource = StringResource(key =
        "catalog_add_subgroup", loader = stringsLoader)

    public actual val catalog_add_product: StringResource = StringResource(key =
        "catalog_add_product", loader = stringsLoader)

    public actual val product_label: StringResource = StringResource(key = "product_label", loader =
        stringsLoader)

    public actual val grams_short: StringResource = StringResource(key = "grams_short", loader =
        stringsLoader)

    public actual val product_weight_grams: StringResource = StringResource(key =
        "product_weight_grams", loader = stringsLoader)

    public actual val catalog_delete: StringResource = StringResource(key = "catalog_delete", loader
        = stringsLoader)

    actual override fun values(): List<StringResource> = listOf(support_email, share_to, text_copy,
        menu, update_message, oops_something_went_wrong, document_rejected, weekday_saturday,
        weekday_friday, weekday_thursday, weekday_wednesday, weekday_tuesday, weekday_monday,
        weekday_sunday, an_error_occurred_please_try_again_later, no_internet_connection,
        please_log_in_again, delivery, favorites, profile, list, map, skip, total_reservations,
        not_picked_reservations, collect_for_lunch, collect_for_dinner, new_surprise_bags, meals,
        selling_fast, left, surprise_bag, collect, what_you_could_get, overall_experience,
        based_on_reviews, reserve, item_selling_fast, surprise_bag_high_demand, confirm, location,
        reservation_success, reservation_success_message, reservation_error,
        reservation_error_message, reservation_id, reservation_number, bag_id, view_bag,
        reserved_on, received_on, status, no_reservations, unlock_for_delivery,
        updating_reservation, reservation_details, released_by_client, reserved, received, error,
        collection_experience, food_quality, variety_of_contents, food_quantity, allergens,
        product_contains_no_allergens, allergen_gluten, allergen_crustaceans, allergen_eggs,
        allergen_fish, allergen_peanuts, allergen_soybeans, allergen_milk, allergen_nuts,
        allergen_celery, allergen_mustard, allergen_sesame, allergen_sulphur_dioxide,
        allergen_lupin, allergen_molluscs, rate_your_experience, rate_your_experience_description,
        submit_review, review_submitted_successfully, bags_count, available_bags, select_time,
        checkout_temporary_problem, try_again, back, checkout_connecting_secure_payment,
        operation_not_supported_by_device, log_out, are_you_sure_you_want_to_proceed,
        continue_camel_case, log_out_yes, cancel, section_account, section_mystybag,
        section_personal_info, section_other, delete_account, submit_request,
        delete_account_request_description, delete_account_request_tap_to_send, your_enquiry,
        contact_support, delete_account_request_sent, delete_account_request_pending_message, name,
        your_name, name_required, mobile_number, change_mobile_number_verification_info,
        notifications, notifications_on_discounts_and_other_news, reservation_completed, push,
        payment_methods, stored_cards_title, cards_section_title, no_stored_cards, help_center,
        about_mystybag, terms_of_use, app_version, unlock_with_fingerprint,
        touch_the_fingerprint_sensor, face_id, use_your_fingerprint, choose_country_region,
        still_having_issue_contact_us, new_update_is_available,
        it_looks_like_you_have_an_older_version, no_results_found, service_temporarily_unavailable,
        not_allowed_symbol,
        go_to_your_phone_settings_allow_access_to_your_contacts_and_send_money_to_your_friends_easily,
        search_by_name_or_mobile_number, you_have_reached_the_maximum_number_of_characters,
        not_allowed_symbol_please_use_only_numbers, contact_us, update, mystybag_new_version, close,
        type_to_search, search_products_and_places, ok, filter, what_can_i_do_title,
        possible_reasons, your_internet_connection_is_not_strong_enough,
        you_have_turned_off_your_wifi_or_mobile_data, your_phone_is_in_plane_mode,
        the_app_cannot_establish_a_secure_connection_with_our_servers, what_can_i_do,
        check_for_app_updates, make_sure_you_re_using_the_latest_version_of_the_app,
        check_your_internet_connection,
        try_using_mystybag_both_on_wifi_and_on_your_mobile_data_connection, restart_your_phone,
        try_restarting_your_phone_it_may_help_to_clear_your_cash_and_data_leaks, reinstall_the_app,
        if_restarting_your_device_and_checking_your_connection_do_not_help, enjoying_mystybag,
        enjoying_mystybag_mind_giving_us_a_5_star_rating_on_play_store, later, rate_us_5_star,
        got_it, please_use_only_latin_letters, permission_not_allowed, crop, black_text, white_text,
        printing_is_unavailable, successfully_saved_to_device, download_failed, storage_permission,
        save_to_my_device, invalid_phone_number, next, personal_details, profile_photo, take_photo,
        open_gallery, remove_photo, please_enter_valid_email_address, camera_permission,
        gallery_permission, login, not_now, enable, phone_number,
        do_you_wish_to_turn_on_face_id_access, do_you_wish_to_turn_on_fingerprint_access, email,
        login_with_fingerprint, login_with_faceID, yesterday, no_notifications_found,
        add_company_contact, company_not_found, section_details, section_price, forgot_password,
        change_password, reset_password, temporary_password, new_password,
        forgot_password_email_sent, password_reset_success, password_requirements_not_met,
        please_enter_temporary_password, collect_today, collect_tomorrow, vegetarian, vegan,
        see_all, dashboard, performance, financials, settings, home, section_application_settings,
        section_appearance, theme_light, theme_dark, theme_system, value, language, email_address,
        change_email_verification_info, bulgarian, english, map_web_placeholder,
        please_select_location_on_map, merchant_location_map_search_hint, view_possible_products,
        reviews_count, no_reviews, open_until, description, available_count, reserve_a_bag,
        how_many_bags_would_you_like_to_reserve, more_available, last_bag, pickup_window_open_title,
        pickup_window_open_message, pickup_walk_time, pickup_drive_time,
        enable_location_for_travel_time, sold_out, no_active_reservations_yet, find_bag,
        my_reservations, tab_active, tab_inactive, tab_history, swipe_to_confirm_collection,
        pickup_address, collection_time_window, amount, leave_review, how_was_your_experience,
        could_be_better_optional, review_could_better_price, review_could_better_pickup_time,
        review_could_better_bag_variety, review_could_better_packaging,
        review_could_better_staff_attitude, add_comment, released_reservations, mark_as_delivered,
        review_rating_freshness, review_rating_quality, review_rating_variety, review_rating_value,
        review_rating_taste, review_rating_presentation, review_rating_portion_size,
        review_rating_coffee_quality, review_rating_service, review_rating_atmosphere,
        review_rating_product_quality, review_rating_packaging, review_rating_service_quality,
        review_rating_professionalism, review_rating_hygiene, review_rating_service_speed,
        review_rating_price, review_rating_accessibility, review_rating_effectiveness,
        review_rating_service_consultation, review_rating_packaging_transport, login_as_merchant,
        sign_in, sign_in_title, dont_have_account, forgot_password_question, login_as_staff,
        what_kind_of_user_are_you, client, merchant, continue_as_merchant, continue_with_facebook,
        continue_with_email, continue_with_google, continue_with_apple, registration,
        login_securely_and_faster, enable_biometric_description, skip_for_now, set_up,
        company_details, company_identifier, your_mobile_number, terms_agreement_prefix,
        general_terms_mystybag, terms_agreement_and, set_new_password, staff, add_employee,
        edit_employee, no_staff, role_staff, role_manager, role_owner, employee_added_successfully,
        employee_updated_successfully, permissions, permission_can_create_bags,
        permission_can_view_revenue, add_your_login_details, login_details_description,
        company_name, please_enter_company_name, company_logo, company_street, merchant_profile,
        category, select_store_type, add_your_merchant_location_details,
        add_merchant_location_title, add_store_screen_title, add_location_products_hint,
        products_added_after_save, grams_with_unit, allergens_section_optional,
        menu_section_optional, edit_merchant_location_title, location_cover_photo,
        add_location_cover_photo, menu_photos, menu_section_header, add_menu_photo,
        menu_photos_up_to_10, store_name, store_details_section, confirm_location,
        tab_location_short, street_name_and_number, city, country, dial_code, phone_number_label,
        location_phone_number, contact_number, packaging, additional_instructions_pickup,
        surprise_bag_contains_buffet_food, bag_contains_products_for_persons_over_18,
        bag_adult_products_disclosure, characters_count, add_your_company_details, first_name_label,
        last_name_label, legal_entity_name, bulstat, bulstat_required, bulstat_invalid_format,
        bulstat_invalid_length, merchant_with_this_bulstat_exists, company_book_lookup_failed,
        privacy_policy, terms_and_conditions, password, confirm_password, passwords_do_not_match,
        at_least_8_characters, at_least_1_number, at_least_1_letter, registered_company_address,
        add, details, add_another_mol, add_mol, mol, delete_mol_confirmation_title,
        delete_mol_confirmation_message, set_weekly_pickup_schedule, pickup_schedule_description,
        name_and_description_description, add_product_description, add_product_item,
        choose_business_image, please_select_business_cover_image, describe_your_products,
        product_name, grams, check_your_inbox, confirm_email_address_title, confirm_email_code_sent,
        check_inbox_email_sent, check_inbox_description, check_inbox_description_2,
        check_inbox_description_3, check_inbox_spam_info, verification_code_title,
        verification_code_email_sent_description, enter_verification_code,
        merchant_registration_phone_sms_sent, sms_verification_code_label, resend_sms_code,
        sms_resend_cooldown_seconds, save, payment_data, payment_data_description, iban,
        invalid_iban, payment_provider_title, payment_provider_mypos, payment_provider_stripe,
        stripe_onboarding_banner_title, stripe_onboarding_banner_message,
        stripe_onboarding_continue, stripe_onboarding_completed, merchant_with_this_iban_exists,
        add_bag, edit_bag, add_first_bag, add_first_bag_message, start_adding_bag, bags, bag,
        reputation, objects, no_bags_found, merchant_bag_depleted_still_active, no_ratings_found,
        all, selected, overall_rating, select_business_category, select_city, please_select_city,
        city_select_description, search_city, no_cities_found, select_country, search_country,
        favorites_colon, review_count_colon, pickup_until, available_colon, reserved_colon,
        total_colon, created_on_colon, store_colon, price_colon, available_bags_colon,
        normal_price_colon, discount_price_colon, average_rating_colon, active_from, active_to,
        bag_is_active, active_short, active_to_must_be_after_active_from, price_normal,
        price_with_discount, optional, discount_percentage, amount_min_error, amount_max_error,
        view_active_bags, view_all_offers, view_all_offers_from, select_location, bag_title,
        distance, create, active_bags_count, price_range_from_to, price_range_single, sold_bags,
        revenue, unpaid_paid, sales_by_day, breakdown_by_location, sales, last_7_days, last_30_days,
        custom_period, select_day, select_month, select_period, start_date, end_date, all_locations,
        filter_by_location, week, last_week, last_month, month, no_sales_data_for_period,
        no_locations_found, overview, all_time, total_sold, paid, unpaid, not_accepted,
        reviews_section, avg_rating, category_name, account_settings, collected, all_reservations,
        declined, for_handover, sold_bags_units, finance, statements, statements_from,
        statements_to, statements_selected_period, statements_total_amount, statements_share,
        statements_period_label, statements_totals_header, statements_column_bag_name,
        statements_column_sale_date, statements_column_amount, statements_column_transaction_ref,
        statements_column_discounted_amount, statements_column_currency, statements_column_withheld,
        statements_column_withheld_currency, statements_no_rows, currency_eur, bank_account,
        business, business_details, object_screen_title, merchant_locations,
        select_at_least_one_location, add_location, rating_label, location_label, employees_label,
        active_bags_label, pickup_schedules, collect_time, bag_details, view_pickup_schedules,
        time_from, time_to, handover_from, handover_to, please_enter_all_required_fields, save_all,
        pickup_schedule_saved_successfully, invalid_pickup_time_range, add_delivery_slot,
        remove_slot, contacts, contacts_persons, company_responsible_persons, confirmed_on,
        pending_confirmation, no_iban_set, no_responsible_persons,
        responsible_person_updated_successfully, responsible_person_details,
        merchant_registration_success, merchant_registration_success_message,
        merchant_registration_under_review_title, merchant_registration_under_review_message,
        proceed_to_login, add_your_first_location, add_location_prompt_message, get_started,
        location_details, no_locations, please_enter_location_title, please_enter_address, address,
        please_enter_phone_number, business_category_bakery, business_category_confectionery,
        business_category_fish_market, business_category_food_for_home, new_group, search_allergen,
        allergen_groups, allergen_groups_section_description,
        set_up_allergen_group_to_apply_to_future_bags, add_new_group, add_allergen_group,
        edit_allergen_group, allergen_group_name, please_enter_group_name,
        select_allergens_for_group, add_allergens_to_the_group, no_allergen_groups,
        select_allergen_group, add_allergens, edit_allergens, section_allergens, your_groups,
        apply_group, delete_allergen_group, delete_allergen_group_confirmation_title,
        delete_allergen_group_confirmation_message, edit_short, deactivate_bag_confirmation_title,
        deactivate_bag_confirmation_message, deactivate_bag_confirm, deactivate_bag_success,
        menu_details, menu_remove, clear_allergen_group_selection, filter_results, reset_filters,
        apply, pickup_location_distance_from_me, use_my_location, filter_location_select_hint,
        price_range, discounted_price_of_the_bag, minimum, maximum, filter_price_max_999,
        enter_amount, merchant_rating, offer_published_date, collection_time, today, last_3_days,
        this_week, this_month, available_now, evening, filter_any, allowed, not_allowed, search,
        section_access_to, products, bag_products, product_selection_title, product_selection_all,
        product_selection_by_category, product_selection_custom, select_product_category,
        product_mode_all_title, product_mode_all_subtitle, product_mode_category_title,
        product_mode_category_subtitle, product_mode_custom_title, product_mode_custom_subtitle,
        product_all_auto_note, search_product_hint, categories_count_suffix,
        selected_products_suffix, no_products, no_product_categories, manage_products,
        manage_product_catalog, add_product, edit_product, add_category, edit_category,
        add_subcategory, product_description, parent_category, no_parent_category,
        product_category_none, product_group, manage_products_create_group_first,
        product_category_required, manage_products_search_hint, products_count_suffix,
        subcategories_count_suffix, product_name_required, product_category_invalid_parent,
        product_enabled, delete_product, delete_product_confirmation_title,
        delete_product_confirmation_message, delete_category, delete_category_confirmation_title,
        delete_category_confirmation_message, products_in_bag_count, products_section_title,
        menu_photos_section_title, catalog_no_categories_yet, catalog_empty_title,
        catalog_empty_subtitle, enter_group_name, product_category_label, product_subcategory_label,
        catalog_add_group, catalog_add_subgroup, catalog_add_product, product_label, grams_short,
        product_weight_grams, catalog_delete)
  }

  public actual object images : ResourceContainer<ImageResource> {
    actual override val __platformDetails: ResourcePlatformDetails = ResourcePlatformDetails()

    public actual val img_welcome_bag: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/img_welcome_bag.png\")") as String, fileName = "img_welcome_bag.png")

    public actual val ic_facebook: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_facebook.png\")") as String, fileName = "ic_facebook.png")

    public actual val ic_apple: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_apple.png\")") as String, fileName = "ic_apple.png")

    public actual val favorite_outline: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/favorite_outline.png\")") as String, fileName =
        "favorite_outline.png")

    public actual val ic_mail: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_mail.png\")") as String, fileName = "ic_mail.png")

    public actual val ic_google: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/ic_google.png\")") as String, fileName = "ic_google.png")

    public actual val faceid_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/faceid_image.png\")") as String, fileName = "faceid_image.png")

    public actual val app_notification_icon_round_white: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/app_notification_icon_round_white.png\")") as String, fileName =
        "app_notification_icon_round_white.png")

    public actual val default_contact: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/default_contact.png\")") as String, fileName = "default_contact.png")

    public actual val active_session_layout_icon: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/active_session_layout_icon.png\")") as String, fileName =
        "active_session_layout_icon.png")

    public actual val feather: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/feather.svg\")") as String, fileName = "feather.svg")

    public actual val favorite_filled: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/favorite_filled.png\")") as String, fileName = "favorite_filled.png")

    public actual val fingerprint_image: ImageResource = ImageResource(fileUrl =
        js("require(\"./images/fingerprint_image.png\")") as String, fileName =
        "fingerprint_image.png")

    actual override fun values(): List<ImageResource> = listOf(img_welcome_bag, ic_facebook,
        ic_apple, favorite_outline, ic_mail, ic_google, faceid_image,
        app_notification_icon_round_white, default_contact, active_session_layout_icon, feather,
        favorite_filled, fingerprint_image)
  }

  public actual object colors : ResourceContainer<ColorResource> {
    actual override val __platformDetails: ResourcePlatformDetails = ResourcePlatformDetails()

    public actual val valueColor: ColorResource = ColorResource(lightColor = Color(0x2fc40aff),
        darkColor = Color(0x2fc40aff))

    public actual val referenceColor: ColorResource = ColorResource(lightColor = Color(0x2fc40aff),
        darkColor = Color(0x2fc40aff))

    public actual val themedColor: ColorResource = ColorResource(lightColor = Color(0xb92743ff),
        darkColor = Color(0x7ccfeeff))

    public actual val themedReferenceColor: ColorResource = ColorResource(lightColor =
        Color(0x2fc40aff), darkColor = Color(0x2fc40aff))

    public actual val background_light_blue: ColorResource = ColorResource(lightColor =
        Color(0x279bd8ff), darkColor = Color(0x279bd8ff))

    public actual val background_red: ColorResource = ColorResource(lightColor = Color(0xde3965ff),
        darkColor = Color(0xde3965ff))

    public actual val background_black: ColorResource = ColorResource(lightColor =
        Color(0x191c1cff), darkColor = Color(0x191c1cff))

    public actual val background_green: ColorResource = ColorResource(lightColor =
        Color(0x07b78dff), darkColor = Color(0x07b78dff))

    public actual val color_F5B12B: ColorResource = ColorResource(lightColor = Color(0xf5b12bff),
        darkColor = Color(0xf5b12bff))

    public actual val color_1CB78D: ColorResource = ColorResource(lightColor = Color(0x1cb78dff),
        darkColor = Color(0x1cb78dff))

    public actual val color_2D2E2F: ColorResource = ColorResource(lightColor = Color(0x2d2e2fff),
        darkColor = Color(0x2d2e2fff))

    public actual val color_3F3F3F: ColorResource = ColorResource(lightColor = Color(0x3f3f3fff),
        darkColor = Color(0x3f3f3fff))

    public actual val color_CF9D47: ColorResource = ColorResource(lightColor = Color(0xcf9d47ff),
        darkColor = Color(0xcf9d47ff))

    public actual val color_error: ColorResource = ColorResource(lightColor = Color(0x9a5351ff),
        darkColor = Color(0x9a5351ff))

    public actual val color_f7505e: ColorResource = ColorResource(lightColor = Color(0xf7505eff),
        darkColor = Color(0xf7505eff))

    public actual val color_f77155: ColorResource = ColorResource(lightColor = Color(0xf77155ff),
        darkColor = Color(0xf77155ff))

    public actual val color_51b990: ColorResource = ColorResource(lightColor = Color(0x51b990ff),
        darkColor = Color(0x51b990ff))

    public actual val color_A54E4E: ColorResource = ColorResource(lightColor = Color(0xa54e4eff),
        darkColor = Color(0xa54e4eff))

    public actual val color_F63059: ColorResource = ColorResource(lightColor = Color(0xf63059ff),
        darkColor = Color(0xf63059ff))

    public actual val color_ECA834: ColorResource = ColorResource(lightColor = Color(0xeca834ff),
        darkColor = Color(0xeca834ff))

    public actual val color_24B894: ColorResource = ColorResource(lightColor = Color(0x24b894ff),
        darkColor = Color(0x24b894ff))

    public actual val notification_icon_color: ColorResource = ColorResource(lightColor =
        Color(0x3ea4d7ff), darkColor = Color(0x3ea4d7ff))

    public actual val tint_icon_color: ColorResource = ColorResource(lightColor = Color(0x279bd7ff),
        darkColor = Color(0x279bd7ff))

    public actual val sr_background: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_on_background: ColorResource = ColorResource(lightColor =
        Color(0x262727ff), darkColor = Color(0x262727ff))

    public actual val sr_primary: ColorResource = ColorResource(lightColor = Color(0x2aa814ff),
        darkColor = Color(0x2aa814ff))

    public actual val sr_on_primary: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_primary_container: ColorResource = ColorResource(lightColor =
        Color(0xe8f9e4ff), darkColor = Color(0xe8f9e4ff))

    public actual val sr_on_primary_container: ColorResource = ColorResource(lightColor =
        Color(0x296812ff), darkColor = Color(0x296812ff))

    public actual val sr_secondary: ColorResource = ColorResource(lightColor = Color(0x5e423eff),
        darkColor = Color(0x5e423eff))

    public actual val sr_on_secondary: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_secondary_container: ColorResource = ColorResource(lightColor =
        Color(0x348227ff), darkColor = Color(0x348227ff))

    public actual val sr_on_secondary_container: ColorResource = ColorResource(lightColor =
        Color(0x5e423eff), darkColor = Color(0x5e423eff))

    public actual val sr_tertiary: ColorResource = ColorResource(lightColor = Color(0xefc200ff),
        darkColor = Color(0xefc200ff))

    public actual val sr_on_tertiary: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_tertiary_container: ColorResource = ColorResource(lightColor =
        Color(0xe5eff4ff), darkColor = Color(0xe5eff4ff))

    public actual val sr_on_tertiary_container: ColorResource = ColorResource(lightColor =
        Color(0xefc200ff), darkColor = Color(0xefc200ff))

    public actual val sr_error: ColorResource = ColorResource(lightColor = Color(0xc82b2bff),
        darkColor = Color(0xc82b2bff))

    public actual val sr_on_error: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_error_container: ColorResource = ColorResource(lightColor =
        Color(0xffebeeff), darkColor = Color(0xffebeeff))

    public actual val sr_on_error_container: ColorResource = ColorResource(lightColor =
        Color(0xc82b2bff), darkColor = Color(0xc82b2bff))

    public actual val sr_surface_dim: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_surface: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_surface_bright: ColorResource = ColorResource(lightColor =
        Color(0xffffffff), darkColor = Color(0xffffffff))

    public actual val sr_inverse_surface: ColorResource = ColorResource(lightColor =
        Color(0x262727ff), darkColor = Color(0x262727ff))

    public actual val sr_inverse_on_surface: ColorResource = ColorResource(lightColor =
        Color(0xe6e6e6ff), darkColor = Color(0xe6e6e6ff))

    public actual val sr_inverse_primary: ColorResource = ColorResource(lightColor =
        Color(0x296812ff), darkColor = Color(0x296812ff))

    public actual val sr_surface_container_lowest: ColorResource = ColorResource(lightColor =
        Color(0xf0f0f0ff), darkColor = Color(0xf0f0f0ff))

    public actual val sr_surface_container_low: ColorResource = ColorResource(lightColor =
        Color(0xecedecff), darkColor = Color(0xecedecff))

    public actual val sr_surface_container: ColorResource = ColorResource(lightColor =
        Color(0xdddfdeff), darkColor = Color(0xdddfdeff))

    public actual val sr_surface_container_high: ColorResource = ColorResource(lightColor =
        Color(0xd5d7d6ff), darkColor = Color(0xd5d7d6ff))

    public actual val sr_surface_container_highest: ColorResource = ColorResource(lightColor =
        Color(0xcfd1d0ff), darkColor = Color(0xcfd1d0ff))

    public actual val sr_on_surface: ColorResource = ColorResource(lightColor = Color(0x262727ff),
        darkColor = Color(0x262727ff))

    public actual val sr_on_surface_variant: ColorResource = ColorResource(lightColor =
        Color(0x838689ff), darkColor = Color(0x838689ff))

    public actual val sr_outline: ColorResource = ColorResource(lightColor = Color(0xe2e2e1ff),
        darkColor = Color(0xe2e2e1ff))

    public actual val sr_outline_variant: ColorResource = ColorResource(lightColor =
        Color(0xdcdcdcff), darkColor = Color(0xdcdcdcff))

    public actual val sr_scrim: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_widget_label_color: ColorResource = ColorResource(lightColor =
        Color(0x262727ff), darkColor = Color(0x262727ff))

    public actual val sr_status_bar_background: ColorResource = ColorResource(lightColor =
        Color(0xffffffff), darkColor = Color(0xffffffff))

    public actual val sr_status_bar_content: ColorResource = ColorResource(lightColor =
        Color(0x262727ff), darkColor = Color(0x262727ff))

    public actual val sr_navigation_bar: ColorResource = ColorResource(lightColor =
        Color(0xffffffff), darkColor = Color(0xffffffff))

    public actual val sr_header_row_first_title: ColorResource = ColorResource(lightColor =
        Color(0x262727ff), darkColor = Color(0x262727ff))

    public actual val sr_header_row_second_title: ColorResource = ColorResource(lightColor =
        Color(0x838689ff), darkColor = Color(0x838689ff))

    public actual val sr_background_dm: ColorResource = ColorResource(lightColor =
        Color(0x16161aff), darkColor = Color(0x16161aff))

    public actual val sr_on_background_dm: ColorResource = ColorResource(lightColor =
        Color(0xffffffff), darkColor = Color(0xffffffff))

    public actual val sr_primary_dm: ColorResource = ColorResource(lightColor = Color(0x2aa814ff),
        darkColor = Color(0x2aa814ff))

    public actual val sr_on_primary_dm: ColorResource = ColorResource(lightColor =
        Color(0xfefefeff), darkColor = Color(0xfefefeff))

    public actual val sr_primary_container_dm: ColorResource = ColorResource(lightColor =
        Color(0xaff99fff), darkColor = Color(0xaff99fff))

    public actual val sr_on_primary_container_dm: ColorResource = ColorResource(lightColor =
        Color(0x348227ff), darkColor = Color(0x348227ff))

    public actual val sr_secondary_dm: ColorResource = ColorResource(lightColor = Color(0x826bd7ff),
        darkColor = Color(0x826bd7ff))

    public actual val sr_on_secondary_dm: ColorResource = ColorResource(lightColor =
        Color(0xffffffff), darkColor = Color(0xffffffff))

    public actual val sr_secondary_container_dm: ColorResource = ColorResource(lightColor =
        Color(0x160e34ff), darkColor = Color(0x160e34ff))

    public actual val sr_on_secondary_container_dm: ColorResource = ColorResource(lightColor =
        Color(0xa393e2ff), darkColor = Color(0xa393e2ff))

    public actual val sr_tertiary_dm: ColorResource = ColorResource(lightColor = Color(0xefc200ff),
        darkColor = Color(0xefc200ff))

    public actual val sr_on_tertiary_dm: ColorResource = ColorResource(lightColor =
        Color(0xffffffff), darkColor = Color(0xffffffff))

    public actual val sr_tertiary_container_dm: ColorResource = ColorResource(lightColor =
        Color(0x0b212dff), darkColor = Color(0x0b212dff))

    public actual val sr_on_tertiary_container_dm: ColorResource = ColorResource(lightColor =
        Color(0x60afd7ff), darkColor = Color(0x60afd7ff))

    public actual val sr_error_dm: ColorResource = ColorResource(lightColor = Color(0xc82b2bff),
        darkColor = Color(0xc82b2bff))

    public actual val sr_on_error_dm: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_error_container_dm: ColorResource = ColorResource(lightColor =
        Color(0xffe2e2ff), darkColor = Color(0xffe2e2ff))

    public actual val sr_on_error_container_dm: ColorResource = ColorResource(lightColor =
        Color(0x9a5351ff), darkColor = Color(0x9a5351ff))

    public actual val sr_surface_dim_dm: ColorResource = ColorResource(lightColor =
        Color(0x0a0a0aff), darkColor = Color(0x0a0a0aff))

    public actual val sr_surface_dm: ColorResource = ColorResource(lightColor = Color(0x1c1c1cff),
        darkColor = Color(0x1c1c1cff))

    public actual val sr_surface_bright_dm: ColorResource = ColorResource(lightColor =
        Color(0x1c1c1cff), darkColor = Color(0x1c1c1cff))

    public actual val sr_inverse_surface_dm: ColorResource = ColorResource(lightColor =
        Color(0xe6e6e6ff), darkColor = Color(0xe6e6e6ff))

    public actual val sr_inverse_on_surface_dm: ColorResource = ColorResource(lightColor =
        Color(0x333333ff), darkColor = Color(0x333333ff))

    public actual val sr_inverse_primary_dm: ColorResource = ColorResource(lightColor =
        Color(0x296812ff), darkColor = Color(0x296812ff))

    public actual val sr_surface_container_lowest_dm: ColorResource = ColorResource(lightColor =
        Color(0x000000ff), darkColor = Color(0x000000ff))

    public actual val sr_surface_container_low_dm: ColorResource = ColorResource(lightColor =
        Color(0x0d0d0dff), darkColor = Color(0x0d0d0dff))

    public actual val sr_surface_container_dm: ColorResource = ColorResource(lightColor =
        Color(0x353535ff), darkColor = Color(0x353535ff))

    public actual val sr_surface_container_high_dm: ColorResource = ColorResource(lightColor =
        Color(0x333333ff), darkColor = Color(0x333333ff))

    public actual val sr_surface_container_highest_dm: ColorResource = ColorResource(lightColor =
        Color(0x4b4b4bff), darkColor = Color(0x4b4b4bff))

    public actual val sr_on_surface_dm: ColorResource = ColorResource(lightColor =
        Color(0xfefefeff), darkColor = Color(0xfefefeff))

    public actual val sr_on_surface_variant_dm: ColorResource = ColorResource(lightColor =
        Color(0xbfbfbfff), darkColor = Color(0xbfbfbfff))

    public actual val sr_outline_dm: ColorResource = ColorResource(lightColor = Color(0x434343ff),
        darkColor = Color(0x434343ff))

    public actual val sr_outline_variant_dm: ColorResource = ColorResource(lightColor =
        Color(0x23232cff), darkColor = Color(0x23232cff))

    public actual val sr_scrim_dm: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val sr_widget_label_color_dm: ColorResource = ColorResource(lightColor =
        Color(0x1c1c1cff), darkColor = Color(0x1c1c1cff))

    public actual val sr_status_bar_background_dm: ColorResource = ColorResource(lightColor =
        Color(0x0a0a0aff), darkColor = Color(0x0a0a0aff))

    public actual val sr_status_bar_content_dm: ColorResource = ColorResource(lightColor =
        Color(0xffffffff), darkColor = Color(0xffffffff))

    public actual val sr_navigation_bar_dm: ColorResource = ColorResource(lightColor =
        Color(0x0a0a0aff), darkColor = Color(0x0a0a0aff))

    public actual val sr_header_row_first_title_dm: ColorResource = ColorResource(lightColor =
        Color(0xffffffff), darkColor = Color(0xffffffff))

    public actual val sr_header_row_second_title_dm: ColorResource = ColorResource(lightColor =
        Color(0xffffffff), darkColor = Color(0xffffffff))

    public actual val vividBlue: ColorResource = ColorResource(lightColor = Color(0x2d5be2ff),
        darkColor = Color(0x2d5be2ff))

    public actual val vividPurple: ColorResource = ColorResource(lightColor = Color(0x8068d2ff),
        darkColor = Color(0x8068d2ff))

    public actual val vividRed: ColorResource = ColorResource(lightColor = Color(0xde3965ff),
        darkColor = Color(0xde3965ff))

    public actual val vividYellow: ColorResource = ColorResource(lightColor = Color(0xf8a90bff),
        darkColor = Color(0xf8a90bff))

    public actual val vividGreen: ColorResource = ColorResource(lightColor = Color(0x07b78dff),
        darkColor = Color(0x07b78dff))

    public actual val amountGreen: ColorResource = ColorResource(lightColor = Color(0x64a180ff),
        darkColor = Color(0x64a180ff))

    public actual val alertOrange: ColorResource = ColorResource(lightColor = Color(0xcd9020ff),
        darkColor = Color(0xcd9020ff))

    public actual val darkMode_background: ColorResource = ColorResource(lightColor =
        Color(0x131f37ff), darkColor = Color(0x131f37ff))

    public actual val color_2576AE: ColorResource = ColorResource(lightColor = Color(0x2576aeff),
        darkColor = Color(0x2576aeff))

    public actual val main_white: ColorResource = ColorResource(lightColor = Color(0xffffffff),
        darkColor = Color(0xffffffff))

    public actual val color_primary: ColorResource = ColorResource(lightColor = Color(0x279bd7ff),
        darkColor = Color(0x279bd7ff))

    actual override fun values(): List<ColorResource> = listOf(valueColor, referenceColor,
        themedColor, themedReferenceColor, background_light_blue, background_red, background_black,
        background_green, color_F5B12B, color_1CB78D, color_2D2E2F, color_3F3F3F, color_CF9D47,
        color_error, color_f7505e, color_f77155, color_51b990, color_A54E4E, color_F63059,
        color_ECA834, color_24B894, notification_icon_color, tint_icon_color, sr_background,
        sr_on_background, sr_primary, sr_on_primary, sr_primary_container, sr_on_primary_container,
        sr_secondary, sr_on_secondary, sr_secondary_container, sr_on_secondary_container,
        sr_tertiary, sr_on_tertiary, sr_tertiary_container, sr_on_tertiary_container, sr_error,
        sr_on_error, sr_error_container, sr_on_error_container, sr_surface_dim, sr_surface,
        sr_surface_bright, sr_inverse_surface, sr_inverse_on_surface, sr_inverse_primary,
        sr_surface_container_lowest, sr_surface_container_low, sr_surface_container,
        sr_surface_container_high, sr_surface_container_highest, sr_on_surface,
        sr_on_surface_variant, sr_outline, sr_outline_variant, sr_scrim, sr_widget_label_color,
        sr_status_bar_background, sr_status_bar_content, sr_navigation_bar,
        sr_header_row_first_title, sr_header_row_second_title, sr_background_dm,
        sr_on_background_dm, sr_primary_dm, sr_on_primary_dm, sr_primary_container_dm,
        sr_on_primary_container_dm, sr_secondary_dm, sr_on_secondary_dm, sr_secondary_container_dm,
        sr_on_secondary_container_dm, sr_tertiary_dm, sr_on_tertiary_dm, sr_tertiary_container_dm,
        sr_on_tertiary_container_dm, sr_error_dm, sr_on_error_dm, sr_error_container_dm,
        sr_on_error_container_dm, sr_surface_dim_dm, sr_surface_dm, sr_surface_bright_dm,
        sr_inverse_surface_dm, sr_inverse_on_surface_dm, sr_inverse_primary_dm,
        sr_surface_container_lowest_dm, sr_surface_container_low_dm, sr_surface_container_dm,
        sr_surface_container_high_dm, sr_surface_container_highest_dm, sr_on_surface_dm,
        sr_on_surface_variant_dm, sr_outline_dm, sr_outline_variant_dm, sr_scrim_dm,
        sr_widget_label_color_dm, sr_status_bar_background_dm, sr_status_bar_content_dm,
        sr_navigation_bar_dm, sr_header_row_first_title_dm, sr_header_row_second_title_dm,
        vividBlue, vividPurple, vividRed, vividYellow, vividGreen, amountGreen, alertOrange,
        darkMode_background, color_2576AE, main_white, color_primary)
  }
}
